import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabaseClient';
import PanouTikTok, { TIKTOK_GOL, campuriTikTok, opreliștiTikTok } from './PanouTikTok';
import { pregatesteFisier, pregatesteLink, urcaElement, avertismenteMedia, formaTinta, potriveste, ramaRetea, CARUSEL_MIN, CARUSEL_MAX, masoaraImagine, masoaraVideoDeLaDistanta, DUCE_COPERTA, feluriCoperta, areCoperta, avertismenteCoperta } from './mediaV2';
import { t, getLocale } from './i18n';
import IntrareV2 from './IntrareV2';
import OraMinut from './OraMinut';
import { lungimePeX, areLinkPeX, LIMITA_X } from './lungimeX';

// ============================================================
// Compozitor v2
//
// Compozitorul nou se construieste ALATURI de cel vechi, nu in locul lui.
// Cel vechi (functia Compositor din App.js, ~1100 de linii) ramane neatins
// pana la comutarea din Faza 7.
//
// Plan complet: COMPOZITOR_PLAN.md; salvarea si publicarea: FAZA6_PLAN.md.
// Stare (15 septembrie 2026): Faza 6 in lucru. Salveaza ciorne; programarea si
// publicarea din carduri vin in pasii urmatori.
// ============================================================

// ---- Poarta ----
// Deschisa pentru toti din 15 septembrie 2026 (decis de Luminita), dupa ce
// s-au incheiat evaluarile Meta si TikTok. Pana atunci se deschidea doar in
// browserul ei, cu semnul ?v2=on, fiindca recenzentii intrau cu credentialele ei.
//
// Ramane o constanta, ca intrarea din meniu sa se scoata dintr-un singur loc la
// Faza 7. Publicarea merge tot pe compozitorul vechi pana la pasii de publicare
// din Faza 6.
export const compozitorV2Vizibil = true;

// ---- Canalele ----
// Datele stau AICI, nu importate din App.js, si asta e intentionat: cele doua
// compozitoare trebuie sa se poata schimba independent pana la comutare, iar un
// import din App.js ar face si o dependenta circulara (App.js importa fisierul
// asta). Dublura dispare singura la Faza 7, cand se sterge compozitorul vechi.
//
// Doar canalele care chiar publica. Compozitorul vechi ofera si YouTube si
// Twitter/X, dar acolo publicarea e simulata: bifezi si nu pleaca nimic. Un canal
// pe care nu-l poti livra n-are ce cauta in selector.
// (Facebook · Event a fost scos din acelasi motiv: nu se poate publica prin API.)
//
// LinkedIn a intrat pe 10 septembrie 2026, dupa ce `linkedin-publish` a fost
// verificata pe viu. Are UN SINGUR format, si asta nu e lene.
//
// La Facebook si Instagram formatele sunt lucruri diferite: un Reel nu e un Feed,
// au reguli si rute separate. La LinkedIn nu exista asa ceva — e o singura postare,
// cu text si, optional, o poza atasata. Aceeasi cerere, acelasi endpoint. Prima
// varianta avea aici „Text" si „Imagine", iar rezultatul era un card numit „Text"
// cu butoane de adaugat poza sub el. Media e optionala, ca la facebook|Feed.
//
// Linkul si videoul lipsesc din alt motiv: „Link" cere in baza coloane care nu
// exista (adresa, titlu, descriere, miniatura — LinkedIn nu extrage singur
// previzualizarea), iar „Video" cere Videos API, nescrisa inca; functia de
// publicare il si refuza explicit.
const CANALE = [
  { id: 'facebook',  label: 'Facebook',  mono: 'FB', culoare: '#1877F2', bg: '#EBF3FF', formate: ['Feed', 'Reel', 'Story', 'Reel script', 'Story text'] },
  { id: 'instagram', label: 'Instagram', mono: 'IG', culoare: '#E1306C', bg: '#FFF0F5', formate: ['Feed', 'Carusel', 'Reel', 'Story', 'Reel script', 'Planse', 'Story text'] },
  { id: 'tiktok',    label: 'TikTok',    mono: 'TT', culoare: '#010101', bg: '#F0F0F0', formate: ['Video', 'Photo Mode', 'Script'] },
  { id: 'linkedin',  label: 'LinkedIn',  mono: 'LI', culoare: '#0A66C2', bg: '#E8F0FB', formate: ['Feed'] },
  // Threads, construit pe 19 septembrie 2026 (THREADS_PLAN.md). Apare in selector
  // INAINTE de aprobarea Meta — abatere de la regula „un canal pe care nu-l poti
  // livra n-are ce cauta in selector", ceruta de Luminita si scrisa in plan: ecranul
  // trebuie sa arate la fel inainte si dupa filmarile de submisie.
  { id: 'threads',   label: 'Threads',   mono: 'TH', culoare: '#000000', bg: '#F5F5F5', formate: ['Feed'] },
  // X, 10 octombrie 2026 (X_PLAN.md). Un singur format: postarea. Fiecare postare COSTA
  // (0,015 $; 0,20 $ cu link), de aceea cardul spune cand textul are un link.
  { id: 'x',         label: 'X',         mono: 'X',  culoare: '#000000', bg: '#F5F5F5', formate: ['Post'] },
  // Presa nu e o retea si n-are cont de conectat. E aici fiindca alegerea se
  // face in acelasi loc cu restul: intrebarea „ce texte vreau" e una singura.
  { id: 'presa',     label: 'Presa',     mono: 'PR', culoare: '#6B7280', bg: '#F3F4F6', formate: ['Comunicat'] },
];

// CARDURILE CARE NU PLEACA PE NICIO RETEA.
//
// Regula compozitorului e „un card, un text". Pana acum, fiecare card era si o
// postare. Astea sunt texte de lucru: scriptul pe care il citesti in fata
// camerei, linia pe care o scrii peste imaginea de Story, titlurile planselor de
// carusel, comunicatul care pleaca la ziaristi. Nu au media, nu au prim
// comentariu, nu au limita de caractere a retelei si nu cer cont conectat —
// scrii un script si fara sa fie legat Facebook-ul clientului.
//
// Cand se face Faza 6 (scrierea in baza), astea NU devin randuri in `postari`.
const FARA_PUBLICARE = [
  'facebook|Reel script', 'facebook|Story text',
  'instagram|Reel script', 'instagram|Planse', 'instagram|Story text',
  'tiktok|Script',
  'presa|Comunicat',
];
export function nuSePublica(cheie) { return FARA_PUBLICARE.includes(cheie); }

// Cardurile de SCRIPT, din toate retelele. Sunt tratate ca unul singur la generare:
// clientul filmeaza un film si il urca peste tot (decizia Luminitei, 18 sept 2026).
const CARDURI_SCRIPT = ['facebook|Reel script', 'instagram|Reel script', 'tiktok|Script'];
export function esteScript(cheie) { return CARDURI_SCRIPT.includes(cheie); }

// Numele formatelor noi se traduc; cele vechi (Feed, Reel, Story) sunt la fel in
// ambele limbi si raman cum sunt.
const ETICHETE_FORMAT = {
  'Reel script': 'fmtReelScript',
  'Story text': 'fmtStoryText',
  Planse: 'fmtPlanse',
  Script: 'fmtScript',
  Comunicat: 'fmtComunicat',
};
function etichetaFormat(f) {
  return ETICHETE_FORMAT[f] ? t('compozitor2', ETICHETE_FORMAT[f]) : f;
}

// Ordinea fixa a cardurilor. Fara ea, cardurile ar sari de la un loc la altul
// dupa ordinea in care bifezi, ceea ce face imposibila compararea lor.
const ORDINE = CANALE.flatMap(c => c.formate.map(f => `${c.id}|${f}`));

// Limita reala de caractere, per canal x format. Zero inseamna ca formatul NU
// primeste text: la Story textul se scrie pe imagine, nu sub ea. Cifrele sunt
// aceleasi cu cele din compozitorul vechi (LIMITE_CARACTERE din App.js).
const LIMITE = {
  'facebook|Feed': 63206, 'facebook|Reel': 2200, 'facebook|Story': 0,
  'instagram|Feed': 2200, 'instagram|Carusel': 2200, 'instagram|Reel': 2200, 'instagram|Story': 0,
  'tiktok|Video': 2200, 'tiktok|Photo Mode': 2200,
  'linkedin|Feed': 3000,
  // 500 de caractere, a doua cea mai stransa limita dupa Story. Nu e LinkedIn
  // scurtat: schimba felul de a scrie, deci si reteta motorului de texte.
  'threads|Feed': 500,
  // 280 pe un cont obisnuit. Pe X NU se numara literele, ci greutati (link = 23, emoji = 2):
  // socoteala e in `lungimeX.js`, iar contorul si verificarea de mai jos o folosesc pe ea.
  'x|Post': LIMITA_X,
};

// Unde taie reteaua textul si pune "Vezi mai mult".
// APROXIMATIV, si asa scrie si pe ecran: pragul difera de la telefon la telefon,
// de la marimea fontului si de la versiunea aplicatiei. Nu e limita (aia e sus,
// in LIMITE), e locul unde te opresti din citit daca primul rand nu te prinde.
// Cifrele se schimba usor de aici daca se dovedesc gresite la ochi.
const TAIERE = {
  'facebook|Feed': 250,
  'facebook|Reel': 100,
  'instagram|Feed': 125, 'instagram|Carusel': 125, 'instagram|Reel': 125,
  'tiktok|Video': 100, 'tiktok|Photo Mode': 100,
  // LinkedIn taie devreme, mai devreme decat toate celelalte: pe telefon se vad
  // vreo 140 de caractere inainte de „vezi mai mult". Pe desktop ceva mai mult,
  // dar cifra mica e cea folositoare la scris.
  'linkedin|Feed': 140,
  // Threads: estimare de pornire, de verificat cu ochii pe telefon. La 500 de
  // caractere cu totul, taierea conteaza mai putin decat pe celelalte retele.
  'threads|Feed': 200,
};

// Coloreaza hashtagurile, fara sa adauge sau sa scoata vreun caracter: orice
// caracter in plus ar dezalinia oglinda de sub caseta de scris.
function cuHashtaguri(text, cheiePrefix) {
  const bucati = String(text).split(/(#[^\s#]+)/g);
  return bucati.map((b, i) =>
    b.startsWith('#')
      ? <span key={`${cheiePrefix}-${i}`} className="v2-hash">{b}</span>
      : <React.Fragment key={`${cheiePrefix}-${i}`}>{b}</React.Fragment>
  );
}

function canalDin(cheie) {
  return CANALE.find(c => c.id === cheie.split('|')[0]);
}
function formatDin(cheie) {
  return cheie.split('|')[1];
}

// Scrisul "in" previzualizare, fara contenteditable.
//
// Caseta de scris e un textarea NORMAL, dar invizibil (text transparent), asezat
// exact peste o oglinda care deseneaza acelasi text, cu aceeasi tipografie, plus
// hashtagurile colorate si partea de dupa taiere stinsa. Tu scrii in caseta,
// ochiul vede oglinda.
//
// De ce nu contenteditable: aduce formatarea din Word la lipire si strica
// spatierea. NM Write a reparat asta de doua ori si tot nu e curat. Un textarea
// obisnuit lipeste text simplu, fara surprize, si se poarta normal cu tastatura
// de telefon, cu dictarea si cu corectarea automata.
//
// Regula de aur: oglinda si caseta trebuie sa aiba EXACT aceleasi proprietati
// de text (font, marime, inaltime de rand, spatiere, padding, latime). Toate
// stau intr-o singura regula CSS, .v2-oglinda si .v2-scriere, ca sa nu poata
// devia una de alta.
// ============================================================
// Primul comentariu.
//
// CINE POATE. Nu toate cele zece formate primesc comentariu, si campul nu se
// pune unde n-are unde sa ajunga — lectia din 22 august, cu campul de text pe
// Story pe care l-am construit inainte sa verific ca Instagram il ignora.
//
//   Facebook Feed si Reel   — da, prin POST /{post_id}/comments
//   Instagram Feed, Carusel, Reel — da, prin POST /{media_id}/comments
//   Facebook si Instagram Story   — NU. Story-urile n-au comentarii deloc.
//   TikTok, ambele formate        — NU. API-ul de publicare TikTok nu are
//        endpoint de comentarii; se poate comenta doar din aplicatie, de mana.
//   LinkedIn Feed — NU, si nu din lipsa de cod. Social Actions API cere
//        `w_member_social_feed`, iar noi avem `w_member_social`. Sunt permisiuni
//        diferite. Verificat pe viu pe 10 septembrie 2026, incercand un comentariu
//        pe o postare inexistenta: raspunsul a fost 403 ACCESS_DENIED, „Not enough
//        permissions to access: partnerApiSocialActions.CREATE" — deci nu tinta
//        lipsea, ci dreptul.
//
//        ATENTIE la capcana in care am cazut inainte de a verifica: ecranul de
//        consimtamant al lui `w_member_social` scrie „Create, modify, and delete
//        posts, COMMENTS, and reactions on your behalf". Textul acela descrie ce
//        poate face permisiunea in principiu, NU la ce rute ai acces. Numele rutei,
//        `partnerApiSocialActions`, spune de ce: e ruta de partener, nu self-serve.
//        Ar cere alt produs din portal, dintre cele cu evaluare.
//
// Permisiunile exista deja: pages_manage_engagement (aprobata 17 august) si
// instagram_manage_comments (in submisia trimisa). Nu cere nicio recenzie noua.
const POATE_COMENTA = [
  'facebook|Feed', 'facebook|Reel',
  'instagram|Feed', 'instagram|Carusel', 'instagram|Reel',
];

// Unde se poate schimba textul DUPA publicare (30 septembrie 2026, functia
// `editeaza-postare`). Facebook probat pe viu pe toate trei tipurile (text, poza,
// reel); Story n-are text. LinkedIn se adauga dupa proba lui. Pe celelalte retele
// API-ul nu permite, iar decizia Luminitei e sa nu scriem nimic acolo.
const POATE_EDITA_PUBLICAT = ['facebook|Feed', 'facebook|Reel'];

// Cat incape intr-un comentariu. Nu e acelasi cu limita postarii.
const LIMITA_COMENTARIU = { facebook: 8000, instagram: 2200 };

// Desparte hashtagurile de la SFARSITUL textului de corpul lui.
//
// Numai cele de la sfarsit, si nu din lene: „mergem la #Ploiesti maine" are
// hashtagul in mijlocul propozitiei. Daca l-am smulge de acolo, am rupe fraza
// omului ca sa castigam un rand. Un bloc de hashtaguri lipit la coada e alta
// treaba — ala chiar e o eticheta, nu o vorba.
export function desparteHashtaguri(text) {
  const intreg = String(text || '');
  const gasit = intreg.match(/(?:^|\s)((?:#[^\s#]+)(?:\s+#[^\s#]+)*)\s*$/);
  if (!gasit) return { corp: intreg.trim(), hashtaguri: '' };
  return {
    corp: intreg.slice(0, gasit.index).trim(),
    hashtaguri: gasit[1].trim().replace(/\s+/g, ' '),
  };
}

// Ce ajunge de fapt in postare si ce ajunge in comentariu, dupa comutator.
// O singura functie, ca ecranul si publicarea sa nu poata ajunge sa socoteasca
// diferit acelasi lucru.
export function textePublicate(cheie, text, comentariu, mutaHash) {
  const brut = String(text || '');
  const com = String(comentariu || '').trim();
  if (!mutaHash || !POATE_COMENTA.includes(cheie)) {
    return { postare: brut, comentariu: com };
  }
  const { corp, hashtaguri } = desparteHashtaguri(brut);
  // Daca textul e NUMAI hashtaguri, mutarea ar lasa postarea goala. Atunci nu
  // se muta nimic: mai bine un comutator care nu face nimic decat o postare
  // fara continut.
  if (!corp) return { postare: brut, comentariu: com };
  const dedesubt = [com, hashtaguri].filter(Boolean).join('\n\n');
  return { postare: corp, comentariu: dedesubt };
}

// Postarea modificata de client prin linkul de aprobare (19 octombrie 2026, APROBARE_CLIENT_PLAN.md,
// pasul 7; forma aleasa de Luminita pe macheta): deasupra casetei, doua etichete. „Textul
// modificat de client" (aprinsa: in caseta e deja textul lui) si „Textul propus", care deschide
// sub caseta textul trimis de agentie, doar de citit.
function cand(iso) {
  const d = new Date(iso);
  const ora = d.toLocaleTimeString(getLocale(), { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === new Date().toDateString()) return t('compozitor2', 'aziLa', { ora });
  return `${d.toLocaleDateString(getLocale(), { day: 'numeric', month: 'short' })}, ${ora}`;
}

export function EticheteModificare({ la, deschis, onComuta }) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
      <span style={{ fontSize: 13, fontWeight: 600, padding: '6px 11px', borderRadius: 8, border: '1.5px solid #E9C46A', background: '#FEF3C7', color: '#8F5310' }}>
        {t('compozitor2', 'textModificatClient')}
        <span style={{ fontWeight: 500, color: '#374151', marginLeft: 6 }}>{cand(la)}</span>
      </span>
      <button type="button" onClick={onComuta} aria-expanded={deschis}
        style={{ fontSize: 13, fontWeight: 600, padding: '6px 11px', borderRadius: 8, border: '1.5px solid #D1E8DA', background: 'white', color: '#1A6B3C', cursor: 'pointer', fontFamily: 'inherit' }}>
        {t('compozitor2', 'textPropus')} {deschis ? '▾' : '▸'}
      </button>
    </div>
  );
}

export function TextPropus({ text }) {
  return (
    <div style={{ marginTop: 8, border: '1.5px dashed #9CA3AF', borderRadius: 10, padding: '10px 12px', fontSize: 14, lineHeight: 1.5, whiteSpace: 'pre-wrap', color: '#374151', background: '#F9FAFB' }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: '#374151', marginBottom: 4 }}>
        {t('compozitor2', 'textPropusTitlu')}
      </div>
      {text}
    </div>
  );
}

export function EditorCard({ cheie, text, onChange, scazut = 0 }) {
  const limita = LIMITE[cheie];
  const taiere = TAIERE[cheie];

  // Story NU primeste camp de text, si nu din lene.
  // Instagram nu afiseaza textul pe story-urile publicate prin API — scrie
  // explicit in instagram-publish, la ramura STORIES. Deci un camp aici ar
  // culege text care n-are unde sa ajunga: l-ai scrie, l-ai aproba, si n-ar
  // aparea nicaieri. Ca sa apara cu adevarat, textul trebuie ars IN imagine,
  // inainte de urcare, ceea ce e alta treaba decat un camp de scris.
  if (limita === 0) {
    return <p className="v2-card-gol">{t('compozitor2', 'faraText')}</p>;
  }

  const inainte = taiere ? text.slice(0, taiere) : text;
  const dupa = taiere ? text.slice(taiere) : '';
  // Cand hashtagurile pleaca in comentariu, contorul trebuie sa arate ce ramane
  // in postare, nu ce e pe ecran. Altfel Instagram pare depasit cand nu e.
  // Marcajul de taiere NU se schimba: hashtagurile stau la coada, iar taierea
  // se uita la primele caractere.
  const lungime = cheie === 'x|Post' ? lungimePeX(text) : Math.max(0, text.length - scazut);
  const depasit = limita && lungime > limita;

  return (
    <>
      <div className="v2-scris">
        <div className="v2-oglinda" aria-hidden="true">
          {cuHashtaguri(inainte, 'a')}
          {dupa && <span className="v2-taiat">{cuHashtaguri(dupa, 'b')}</span>}
          {'​'}
        </div>
        <textarea
          className="v2-scriere"
          value={text}
          onChange={e => onChange(e.target.value)}
          placeholder={t('compozitor2', 'scrieAici')}
          spellCheck={true}
        />
      </div>
      <div className="v2-sub">
        <span className={depasit ? 'v2-contor depasit' : 'v2-contor'}>
          {lungime}{limita ? ` / ${limita}` : ''}
          {scazut > 0 && <em className="v2-scazut">{t('compozitor2', 'faraHashtaguri')}</em>}
        </span>
        {taiere && text.length > taiere && (
          <span className="v2-legenda" title={t('compozitor2', 'taiereTooltip')}>
            {t('compozitor2', 'taiereLegenda', { n: taiere })}
          </span>
        )}
        {cheie === 'x|Post' && areLinkPeX(text) && (
          <span className="v2-legenda v2-legenda-bani">{t('compozitor2', 'xCostLink')}</span>
        )}
      </div>
    </>
  );
}

// Blocul de prim comentariu de pe card. Strans by default: noua carduri cu
// cate o caseta deschisa ar face ecranul un perete.
// ============================================================
// Linkul din postare.
//
// Doar pe LinkedIn, si nu din intamplare: e singura retea de la noi care NU
// citeste pagina ca sa-si faca singura previzualizarea. Documentatia lor o scrie
// direct: „The Posts API does not support URL scraping". Deci titlul, descrierea
// si miniatura pleaca de la noi, sau linkul apare gol in feed.
//
// Facebook si Instagram nu au nevoie de asta: le dai adresa in text si se descurca.
//
// NU e un format separat, e o optiune a postarii. Aceeasi lectie ca la „Text" si
// „Imagine": la LinkedIn exista o singura postare, care poate avea un link, un
// film sau o poza. Un format „Link" ar fi produs un card cu buton de adaugat poza
// sub el.
//
// Miniatura foloseste media cardului, ca in compozitorul vechi: daca ai pus si
// link, si poza, poza devine miniatura linkului.
// ============================================================
export function BlocLink({ cheie, valoare, onChange }) {
  const v = valoare || {};
  const [deschis, setDeschis] = useState(!!v.url);

  if (canalDin(cheie).id !== 'linkedin') return null;

  const seteaza = (camp, val) => onChange({ ...v, [camp]: val });

  if (!deschis) {
    return (
      <button type="button" className="v2-com-deschide" onClick={() => setDeschis(true)}>
        {t('compozitor2', 'adaugaLinkPostare')}
      </button>
    );
  }

  return (
    <div className="v2-com">
      <div className="v2-com-cap">
        <span className="v2-com-titlu">{t('compozitor2', 'linkTitlu')}</span>
        <button
          type="button"
          className="v2-com-inchide"
          onClick={() => { setDeschis(false); onChange({}); }}
        >
          {t('compozitor2', 'renunta')}
        </button>
      </div>
      <input
        className="v2-link-camp"
        type="url"
        placeholder={t('compozitor2', 'linkAdresa')}
        value={v.url || ''}
        onChange={e => seteaza('url', e.target.value)}
      />
      {(v.url || '').trim() && (
        <>
          <input
            className="v2-link-camp"
            placeholder={t('compozitor2', 'linkTitluPlaceholder')}
            value={v.titlu || ''}
            onChange={e => seteaza('titlu', e.target.value)}
          />
          <textarea
            className="v2-link-camp"
            rows={2}
            placeholder={t('compozitor2', 'linkDescrierePlaceholder')}
            value={v.descriere || ''}
            onChange={e => seteaza('descriere', e.target.value)}
          />
          <p className="v2-com-ajutor">{t('compozitor2', 'linkAjutor')}</p>
        </>
      )}
    </div>
  );
}

// ============================================================
// Coperta filmului.
//
// Apare doar pe cardurile care duc video si numai cu ce stie reteaua sa ia:
// Facebook doar poza, TikTok doar secunda, Instagram amandoua (vezi
// `feluriCoperta` din mediaV2.js). Blocul nu se deseneaza deloc cat timp cardul
// n-are film — o coperta fara film n-are ce acoperi.
//
// Inchiderea cu „×" nu ascunde doar blocul, ci SCOATE coperta. Pe un card care
// o mosteneste din bara comuna, asta inseamna „aici, fara coperta" — de aia
// valoarea proprie a unui card poate fi si `null`, nu doar lipsa.
// ============================================================
// ============================================================
// Alegerea cadrului din film, ca pe telefon: tragi si vezi.
//
// De ce exista: la TikTok coperta E o secunda, iar o cifra scrisa de mana e o
// ghicitoare — nu stii ce cadru pica acolo pana nu publici. Si mai e ceva:
// Facebook nu primeste secunde deloc, doar poze, deci SINGURA cale ca un cadru
// din film sa ajunga coperta pe Facebook e sa-l decupam noi aici.
//
// Decuparea cere ca serverul filmului sa dea voie browserului sa-i citeasca
// pixelii. Depozitul nostru da (`Access-Control-Allow-Origin: *`, verificat pe
// 19 septembrie 2026); un film adus prin link de pe alt server poate sa nu dea,
// iar atunci cererea cu acces nici nu incarca filmul. De aia se incarca A DOUA
// oara, fara ea: tragerea si secunda merg mai departe, se stinge doar decuparea,
// cu motivul scris. Un buton care nu merge si nu spune de ce e mai rau decat un
// buton lipsa.
// ============================================================
export function AlegeCadru({ video, msInitial, poatePoza, poateSecunda, onAlege, onInchide }) {
  const ref = useRef(null);
  const [durata, setDurata] = useState((video && video.durataSec) || 0);
  const [secunda, setSecunda] = useState(Number.isFinite(msInitial) ? msInitial / 1000 : 0);
  const [cuAcces, setCuAcces] = useState(true);
  const [lucreaza, setLucreaza] = useState(false);
  const [nota, setNota] = useState('');

  useEffect(() => {
    function laTasta(e) { if (e.key === 'Escape') onInchide(); }
    document.addEventListener('keydown', laTasta);
    return () => document.removeEventListener('keydown', laTasta);
  }, [onInchide]);

  const sursa = video ? (video.url || video.previzualizare) : null;
  if (!sursa) return null;

  const virgula = getLocale() === 'en' ? '.' : ',';

  function muta(s) {
    setSecunda(s);
    // Sariturile prea dese pe un film de pe alt server pot arunca; nu darama
    // ecranul pentru atat.
    try { if (ref.current) ref.current.currentTime = s; } catch (_e) { /* ramane unde e */ }
  }

  async function iaCadrul() {
    const v = ref.current;
    if (!v || !v.videoWidth) { setNota(t('compozitor2', 'cadruNeincarcat')); return; }
    setLucreaza(true);
    try {
      // Daca filmul inca sare la secunda ceruta, cadrul desenat ar fi cel vechi.
      if (v.seeking) await new Promise(gata => v.addEventListener('seeked', gata, { once: true }));
      const panza = document.createElement('canvas');
      panza.width = v.videoWidth;
      panza.height = v.videoHeight;
      panza.getContext('2d').drawImage(v, 0, 0, panza.width, panza.height);
      const blob = await new Promise((rezolva, respinge) => {
        try {
          panza.toBlob(b => (b ? rezolva(b) : respinge(new Error('cadru gol'))), 'image/jpeg', 0.92);
        } catch (e) { respinge(e); }
      });
      const nume = `coperta-${secunda.toFixed(2).replace('.', '_')}.jpg`;
      onAlege({ ms: Math.round(secunda * 1000), fisier: new File([blob], nume, { type: 'image/jpeg' }) });
    } catch (_e) {
      setNota(t('compozitor2', 'cadruFaraAcces'));
      setLucreaza(false);
    }
  }

  return (
    <div className="v2-lupa-fundal" onClick={onInchide} role="presentation">
      <div className="v2-lupa-continut" onClick={e => e.stopPropagation()} role="presentation">
        <video
          key={cuAcces ? 'cu-acces' : 'fara-acces'}
          ref={ref}
          src={sursa}
          crossOrigin={cuAcces ? 'anonymous' : undefined}
          preload="auto"
          muted
          playsInline
          onLoadedMetadata={e => {
            const d = e.target.duration;
            if (Number.isFinite(d) && d > 0) setDurata(d);
            muta(Number.isFinite(d) && secunda > d ? d : secunda);
          }}
          onError={() => {
            if (cuAcces) { setCuAcces(false); setNota(t('compozitor2', 'cadruFaraAcces')); }
            else setNota(t('compozitor2', 'cadruNeincarcat'));
          }}
        />
        <div className="v2-cadru-rand">
          <input
            type="range"
            min="0"
            max={durata || 0}
            step="0.05"
            value={secunda}
            aria-label={t('compozitor2', 'alegeCadru')}
            onChange={e => muta(Number(e.target.value))}
          />
          <span className="v2-cadru-secunda">
            {secunda.toFixed(2).replace('.', virgula)} s
          </span>
        </div>
        <p className="v2-cadru-nota">{nota || t('compozitor2', 'cadruAjutor')}</p>
        <div className="v2-lupa-jos">
          {poatePoza && (
            <button type="button" className="v2-btn-media mic"
              disabled={!cuAcces || lucreaza} onClick={iaCadrul}>
              {lucreaza ? t('compozitor2', 'cadruSeIa') : t('compozitor2', 'cadruIaPoza')}
            </button>
          )}
          {poateSecunda && (
            <button type="button" className="v2-btn-media mic"
              onClick={() => onAlege({ ms: Math.round(secunda * 1000) })}>
              {t('compozitor2', 'cadruPuneSecunda')}
            </button>
          )}
          <button type="button" className="v2-btn-media mic" onClick={onInchide}>
            {t('compozitor2', 'inchide')}
          </button>
        </div>
      </div>
    </div>
  );
}

// Secunda, scrisa cum o scrie omul: cu virgula in romana, cu punct in engleza.
//
// Campul NU mai e `type="number"`. Pe Chrome cu setari englezesti, un camp de
// numere refuza virgula din tastatura — apesi 3, virgula, 5 si ramai cu „3".
// Gasit pe viu de Luminita, la prima proba de coperta pe TikTok, 19 sept 2026.
function secundaScrisa(ms) {
  if (!Number.isFinite(ms)) return '';
  const s = String(Math.round(ms / 100) / 10);
  return getLocale() === 'en' ? s : s.replace('.', ',');
}

// Cadrul de la secunda aleasa, ca miniatura (17 octombrie 2026). Pe Facebook coperta
// e o poza, deci se vedea; pe Instagram fara poza si pe TikTok ramanea doar cifra, iar
// omul nu stia ce a ales. E chiar filmul, oprit la secunda aceea, nu o decupare cu
// `canvas`: un `<video>` arata cadrul si cand serverul filmului nu da voie la pixeli.
// Doar se arata — ce pleaca la retea ramane secunda.
function MiniaturaCadru({ video, ms }) {
  const ref = useRef(null);
  const sursa = video ? (video.url || video.previzualizare) : null;

  function sari(v, cat) {
    if (!v || !Number.isFinite(cat)) return;
    const d = v.duration;
    const s = cat / 1000;
    try { v.currentTime = Number.isFinite(d) && d > 0 ? Math.min(s, d) : s; } catch (_e) { /* ramane unde e */ }
  }

  // Inainte sa stie durata, filmul n-are unde sari; atunci sare `onLoadedMetadata`.
  useEffect(() => { if (ref.current && ref.current.readyState >= 1) sari(ref.current, ms); }, [ms]);

  if (!sursa) return null;
  return (
    <span className="v2-coperta-poza" title={t('compozitor2', 'copertaTitlu')}>
      <video ref={ref} src={sursa} preload="auto" muted playsInline onLoadedMetadata={e => sari(e.target, ms)} />
    </span>
  );
}

export function BlocCoperta({ cheie, valoare, video, dinComuna, onPoza, onSchimba, onRevino }) {
  const [deschisManual, setDeschisManual] = useState(false);
  // Ce are omul sub degete cat scrie. „3," nu e un numar, deci n-are ce cauta in
  // valoarea salvata, dar trebuie sa ramana pe ecran pana termina de scris.
  const [ciorna, setCiorna] = useState(null);
  const [alegeCadru, setAlegeCadru] = useState(false);
  // Fara cheie inseamna bara comuna, care nu e a niciunei retele: acolo se pot
  // pune amandoua, si fiecare card ia ce stie sa duca.
  const feluri = cheie ? feluriCoperta(cheie) : { poza: true, secunda: true };
  const c = valoare || {};
  const deschis = deschisManual || areCoperta(c);

  if (!feluri.poza && !feluri.secunda) return null;
  if (!video) return null;

  const poza = c.previzualizare || c.url || null;
  const durata = video.durataSec || 0;

  if (!deschis) {
    return (
      <button type="button" className="v2-com-deschide" onClick={() => setDeschisManual(true)}>
        {t('compozitor2', 'adaugaCoperta')}
      </button>
    );
  }

  const ajutor = !cheie
    ? 'copertaAjutorComuna'
    : ((feluri.poza && feluri.secunda)
      ? 'copertaAjutor'
      : (feluri.poza ? 'copertaAjutorPoza' : 'copertaAjutorSecunda'));

  return (
    <div className="v2-com v2-coperta">
      <div className="v2-com-cap">
        <span className="v2-com-titlu">{t('compozitor2', 'copertaTitlu')}</span>
        {dinComuna && <span className="v2-eticheta-comuna">{t('compozitor2', 'dinComuna')}</span>}
        <button
          type="button"
          className="v2-com-inchide"
          title={t('compozitor2', 'copertaScoate')}
          aria-label={t('compozitor2', 'copertaScoate')}
          onClick={() => { setDeschisManual(false); onSchimba(null); }}
        >
          ×
        </button>
      </div>
      <div className="v2-coperta-rand">
        {/* Miniatura arata ce ia reteaua cardului: poza, unde o primeste (ea bate
            secunda), altfel cadrul de la secunda. TikTok nu ia poze, deci acolo se
            vede mereu cadrul, chiar daca bara comuna are o poza. */}
        {poza && feluri.poza ? (
          <span className={`v2-coperta-poza${c.seIncarca ? ' se-urca' : ''}`}>
            <img src={poza} alt={t('compozitor2', 'copertaTitlu')} />
          </span>
        ) : (feluri.secunda && Number.isFinite(c.ms) && (
          <MiniaturaCadru video={video} ms={c.ms} />
        ))}
        {feluri.poza && (
          <label className="v2-btn-media mic">
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={e => { onPoza(e.target.files); e.target.value = ''; }}
            />
            {poza ? t('compozitor2', 'copertaSchimbaPoza') : t('compozitor2', 'copertaPunePoza')}
          </label>
        )}
        <button type="button" className="v2-btn-media mic" onClick={() => setAlegeCadru(true)}>
          {t('compozitor2', 'alegeCadru')}
        </button>
        {feluri.poza && poza && (
          <button
            type="button"
            className="v2-btn-media mic"
            onClick={() => onSchimba({
              ...c, url: null, cale: null, previzualizare: null,
              raport: 0, nume: null, eroare: null, seIncarca: false,
            })}
          >
            {t('compozitor2', 'copertaScoatePoza')}
          </button>
        )}
        {feluri.secunda && (
          <label className="v2-coperta-secunda">
            <span>{t('compozitor2', 'copertaSecunda')}</span>
            <input
              type="text"
              inputMode="decimal"
              size={5}
              value={ciorna !== null ? ciorna : secundaScrisa(c.ms)}
              onChange={e => {
                const brut = e.target.value;
                setCiorna(brut);
                const curat = brut.trim().replace(',', '.');
                if (curat === '') { onSchimba({ ...c, ms: null }); return; }
                // Numai cifre si o singura virgula sau punct. „3," in timpul
                // scrierii nu e inca un numar, deci se tine in ciorna si atat.
                if (!/^\d*\.?\d*$/.test(curat)) return;
                let s = Number(curat);
                if (!Number.isFinite(s) || s < 0) return;
                // Filmul masurat da plafonul. Un link nemasurat n-are durata, si
                // atunci nu inventam una: cifra pleaca asa cum a scris-o omul.
                if (durata && s > durata) s = durata;
                onSchimba({ ...c, ms: Math.round(s * 1000) });
              }}
              onBlur={() => setCiorna(null)}
            />
          </label>
        )}
        {onRevino && !dinComuna && (
          <button type="button" className="v2-btn-media mic" onClick={onRevino}>
            {t('compozitor2', 'revinoComuna')}
          </button>
        )}
      </div>
      <p className="v2-com-ajutor">{t('compozitor2', ajutor)}</p>
      {alegeCadru && (
        <AlegeCadru
          video={video}
          msInitial={c.ms}
          poatePoza={feluri.poza}
          poateSecunda={feluri.secunda}
          onInchide={() => setAlegeCadru(false)}
          onAlege={({ ms, fisier }) => {
            setAlegeCadru(false);
            setCiorna(null);
            // Cadrul decupat pleaca pe acelasi drum ca orice poza de coperta, cu
            // secunda dusa odata cu el: pe bara comuna, o singura alegere
            // serveste toate trei retelele — poza la Facebook si Instagram,
            // secunda la TikTok.
            if (fisier) onPoza([fisier], ms);
            else onSchimba({ ...c, ms });
          }}
        />
      )}
    </div>
  );
}

// Titlul postarii cu poze de pe TikTok (13 octombrie 2026). TikTok il arata ingrosat,
// deasupra descrierii. Pana acum publicarea il taia singura din primele 90 de caractere
// ale textului, deci iesea rupt in mijlocul unui cuvant si repeta inceputul textului.
// Campul sta mereu deschis, nu ascuns dupa un „+": un titlu uitat se vede pe postare.
// `.length` numara unitati UTF-16, exact cum numara si TikTok (un emoji nou face doua).
export const TITLU_TIKTOK_MAX = 90;
const CARD_CU_TITLU = 'tiktok|Photo Mode';

export function BlocTitluTikTok({ cheie, valoare, onChange }) {
  if (cheie !== CARD_CU_TITLU) return null;
  const lungime = (valoare || '').length;
  const depasit = lungime > TITLU_TIKTOK_MAX;
  return (
    <div className="v2-com" style={{ marginTop: 0, marginBottom: 10 }}>
      <div className="v2-com-cap">
        <span className="v2-com-titlu">{t('compozitor2', 'titluTikTok')}</span>
      </div>
      <input
        type="text"
        className="v2-link-camp"
        value={valoare || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={t('compozitor2', 'titluTikTokAici')}
        spellCheck={true}
      />
      <div className="v2-sub">
        <span className={depasit ? 'v2-contor depasit' : 'v2-contor'}>
          {lungime} / {TITLU_TIKTOK_MAX}
        </span>
      </div>
      {!(valoare || '').trim() && (
        <p className="v2-com-ajutor">{t('compozitor2', 'titluTikTokAjutor')}</p>
      )}
    </div>
  );
}

export function BlocComentariu({ cheie, valoare, onChange, mutaHash, onMutaHash, textPostare }) {
  const [deschis, setDeschis] = useState(!!valoare);

  if (!POATE_COMENTA.includes(cheie)) {
    // Pe Story nu spunem nimic: cardul n-are nici macar camp de text, deci
    // nimeni nu se asteapta la comentariu. Pe TikTok cardul ARATA ca celelalte,
    // deci lipsa trebuie explicata, altfel pare scapare.
    if (canalDin(cheie).id !== 'tiktok') return null;
    return <p className="v2-com-nu">{t('compozitor2', 'comTikTok')}</p>;
  }

  const canal = canalDin(cheie).id;
  const limita = LIMITA_COMENTARIU[canal] || 2200;
  const { corp, hashtaguri } = desparteHashtaguri(textPostare || '');
  const arePeCeMuta = !!hashtaguri && !!corp;
  const lungime = (valoare || '').length;
  const depasit = lungime > limita;

  if (!deschis) {
    return (
      <button type="button" className="v2-com-deschide" onClick={() => setDeschis(true)}>
        {t('compozitor2', 'adaugaComentariu')}
      </button>
    );
  }

  return (
    <div className="v2-com">
      <div className="v2-com-cap">
        <span className="v2-com-titlu">{t('compozitor2', 'primulComentariu')}</span>
        <button
          type="button"
          className="v2-com-inchide"
          title={t('compozitor2', 'ascunde')}
          aria-label={t('compozitor2', 'ascunde')}
          onClick={() => setDeschis(false)}
        >
          −
        </button>
      </div>
      <textarea
        className="v2-com-scriere"
        value={valoare || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={t('compozitor2', 'comentariuAici')}
        spellCheck={true}
        rows={2}
      />
      <div className="v2-sub">
        <span className={depasit ? 'v2-contor depasit' : 'v2-contor'}>
          {lungime} / {limita}
        </span>
      </div>
      {arePeCeMuta && (
        <label className="v2-com-muta">
          <input type="checkbox" checked={!!mutaHash} onChange={e => onMutaHash(e.target.checked)} />
          <span>{t('compozitor2', 'mutaHashtaguri')}</span>
        </label>
      )}
      {arePeCeMuta && mutaHash && (
        <p className="v2-com-mutate">{hashtaguri}</p>
      )}
    </div>
  );
}


// Galeria de media: se foloseste si in bara comuna, si pe fiecare card.
// „Comuna" e implicita, cardul o poate suprascrie. Modelul e cel din Meta
// Business Suite: aceeasi poza peste tot, cu exceptii unde vrei.
export function Galerie({ elemente, onSterge, etichetaGoala, onDeschide, onMuta, cheie }) {
  if (!elemente.length) return <span className="v2-media-goala">{etichetaGoala}</span>;
  const maiMulte = elemente.length > 1;
  return (
    <div className="v2-galerie">
      {elemente.map((el, i) => (
        <div key={el.id} className={`v2-miniatura${el.eroare ? ' eroare' : ''}`}>
          <button type="button" className="v2-lupa" title={t('compozitor2', 'vezMare')}
            onClick={() => onDeschide && onDeschide({ el, cheie: cheie || null })}>
            {el.tip === 'imagine'
              ? <img src={el.previzualizare || el.url} alt={el.nume} />
              : <video src={el.previzualizare || el.url} muted playsInline />}
          </button>
          {/* Numarul apare doar cand sunt mai multe: la carusel, ordinea e continut. */}
          {maiMulte && <span className="v2-pozitie">{i + 1}</span>}
          {!el.url && !el.eroare && <span className="v2-urca">{t('compozitor2', 'seUrca')}</span>}
          {/* Un link nu e al nostru. Daca fisierul se muta sau se opreste
              partajarea, o postare programata pica peste zile. Semnul e mic,
              dar trebuie sa fie acolo: altfel nimic nu deosebeste un video pe
              care il tinem noi de unul care depinde de dosarul altcuiva. */}
          {el.esteLink && el.url && (
            <span className="v2-semn-link" title={t('compozitor2', 'esteLinkTitlu')}>&#128279;</span>
          )}
          {el.eroare && <span className="v2-urca eroare" title={el.eroare}>!</span>}
          {onSterge && (
            <button type="button" className="v2-scoate" onClick={() => onSterge(el.id)}
              aria-label={t('compozitor2', 'scoateMedia')} title={t('compozitor2', 'scoateMedia')}>×</button>
          )}
          <div className="v2-jos">
            {el.tip === 'video' ? <span className="v2-marcaj-video">▶</span> : <span />}
            {/* Sageti, nu tras cu degetul: pe telefon, trasul se bate cu derularea
                paginii, iar la carusel ordinea trebuie sa fie exacta, nu aproximativa. */}
            {maiMulte && onMuta && (
              <span className="v2-sageti">
                <button type="button" disabled={i === 0} onClick={() => onMuta(el.id, -1)}
                  aria-label={t('compozitor2', 'mutaInainte')} title={t('compozitor2', 'mutaInainte')}>‹</button>
                <button type="button" disabled={i === elemente.length - 1} onClick={() => onMuta(el.id, 1)}
                  aria-label={t('compozitor2', 'mutaInapoi')} title={t('compozitor2', 'mutaInapoi')}>›</button>
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

// Mesajele de avertisment se scriu cu chei literale, nu construite din cod:
// t() intoarce in tacere [sectiune.cheie] la cheie lipsa, iar verificarea
// programatica gaseste doar ce e scris intreg.
function numeCanal(id) {
  const c = CANALE.find(x => x.id === id);
  return c ? c.label : id;
}

function textAvertisment(m) {
  if (m.cod === 'faraMedia') return t('compozitor2', 'avFaraMedia');
  if (m.cod === 'caruselPreaPutine') return t('compozitor2', 'avCaruselPutine', { n: m.n, min: CARUSEL_MIN });
  if (m.cod === 'caruselPreaMulte') return t('compozitor2', 'avCaruselMulte', { n: m.n, max: CARUSEL_MAX });
  if (m.cod === 'micsorata') return t('compozitor2', 'avMicsorata', { nume: m.nume, de: m.de, la: m.la });
  if (m.cod === 'taieSusJos') return t('compozitor2', 'avTaieSusJos', { nume: m.nume, raport: m.raport, canal: numeCanal(m.canal) });
  if (m.cod === 'taieLaterale') return t('compozitor2', 'avTaieLaterale', { nume: m.nume, raport: m.raport, canal: numeCanal(m.canal) });
  if (m.cod === 'nuUmpleEcranul') return t('compozitor2', 'avNuUmpleEcranul', { nume: m.nume, raport: m.raport });
  if (m.cod === 'doarPrima') return t('compozitor2', 'avDoarPrima', { format: m.format, n: m.n });
  if (m.cod === 'videoNuUmpleEcranul') return t('compozitor2', 'avVideoNuUmple', { nume: m.nume, raport: m.raport });
  if (m.cod === 'linkNemasurat') return t('compozitor2', 'avLinkNemasurat', { nume: m.nume });
  if (m.cod === 'tiktokMemorie') return t('compozitor2', 'avTiktokMemorie', { mb: m.mb, limita: m.limita });
  if (m.cod === 'pesteDepozit') return t('compozitor2', 'avPesteDepozit', { nume: m.nume, mb: m.mb, limita: m.limita });
  if (m.cod === 'storyVideoPreaMic') return t('compozitor2', 'avStoryVideoMic', { l: m.l, i: m.i });
  if (m.cod === 'cereVideo') return t('compozitor2', 'avCereVideo', { format: m.format });
  if (m.cod === 'cereImagini') return t('compozitor2', 'avCereImagini', { format: m.format });
  if (m.cod === 'caruselRapoarteDiferite') return t('compozitor2', 'avCaruselForme');
  if (m.cod === 'feedDevineCarusel') return t('compozitor2', 'avFeedCarusel', { n: m.n });
  if (m.cod === 'preaMultePoze') return t('compozitor2', 'avPreaMultePoze', { n: m.n, max: m.max, format: m.format });
  if (m.cod === 'multeDoarImagini') return t('compozitor2', 'avMulteDoarImagini', { format: m.format });
  if (m.cod === 'videoPreaMare') return t('compozitor2', 'avVideoMare', { nume: m.nume, mb: m.mb, limita: m.limita });
  if (m.cod === 'nuAUrcat') return t('compozitor2', 'avNuAUrcat', { nume: m.nume });
  if (m.cod === 'copertaCereSecunda') return t('compozitor2', 'avCopertaCereSecunda', { canal: numeCanal(m.canal) });
  if (m.cod === 'copertaCerePoza') return t('compozitor2', 'avCopertaCerePoza', { canal: numeCanal(m.canal) });
  if (m.cod === 'copertaAltaForma') return t('compozitor2', 'avCopertaAltaForma');
  if (m.cod === 'copertaPesteDurata') return t('compozitor2', 'avCopertaPesteDurata', { s: m.s, durata: m.durata });
  if (m.cod === 'copertaNuAUrcat') return t('compozitor2', 'avCopertaNuAUrcat');
  return m.cod;
}

// Lupa. Se inchide cu Escape, cu clic in afara si cu butonul — trei iesiri,
// pentru ca o fereastra care se inchide greu e mai enervanta decat una care
// lipseste.
export function Lupa({ tinta, onInchide }) {
  useEffect(() => {
    function laTasta(e) { if (e.key === 'Escape') onInchide(); }
    document.addEventListener('keydown', laTasta);
    return () => document.removeEventListener('keydown', laTasta);
  }, [onInchide]);

  const element = tinta && tinta.el;
  if (!element) return null;
  const sursa = element.url || element.previzualizare;

  // Rama se deseneaza doar cand stim pe ce card se uita omul. In bara comuna nu
  // se stie: aceeasi poza pleaca pe canale cu rame diferite, iar una singura ar
  // minti. Tot null intoarce si pentru TikTok, care nu are interval declarat.
  const rama = element.tip === 'imagine'
    ? ramaRetea(tinta.cheie, element.raport)
    : null;
  const procent = rama ? `${(rama.procent * 100).toFixed(1)}%` : '0%';
  const numeleCanalului = tinta.cheie ? numeCanal(String(tinta.cheie).split('|')[0]) : '';

  return (
    <div className="v2-lupa-fundal" onClick={onInchide} role="presentation">
      <div className="v2-lupa-continut" onClick={e => e.stopPropagation()} role="presentation">
        <div className="v2-lupa-cadru">
          {element.tip === 'imagine'
            ? <img src={sursa} alt={element.nume} />
            : <video src={sursa} controls autoPlay />}
          {rama && (
            <>
              <div className={`v2-rama-umbra ${rama.taie}`} style={rama.taie === 'laterale'
                ? { left: 0, width: procent } : { top: 0, height: procent }} />
              <div className={`v2-rama-umbra ${rama.taie}`} style={rama.taie === 'laterale'
                ? { right: 0, width: procent } : { bottom: 0, height: procent }} />
              <div className="v2-rama-chenar" style={rama.taie === 'laterale'
                ? { left: procent, right: procent, top: 0, bottom: 0 }
                : { top: procent, bottom: procent, left: 0, right: 0 }} />
            </>
          )}
        </div>
        {rama && (
          <div className="v2-rama-explicatie">
            {t('compozitor2', rama.taie === 'laterale' ? 'ramaTaieLaterale' : 'ramaTaieSusJos',
              { canal: numeleCanalului, procent })}
          </div>
        )}
        <div className="v2-lupa-jos">
          <span className="v2-lupa-nume">{element.nume}</span>
          <button type="button" className="v2-btn-media mic" onClick={onInchide}>
            {t('compozitor2', 'inchide')}
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// Faza 6 — salvarea (FAZA6_PLAN.md, Pasul 2)
//
// Un rand in `postari` pentru fiecare card care se publica, toate cu acelasi
// `grup_id`. Textele de lucru (FARA_PUBLICARE) nu se scriu.
//
// Salvarea e automata, la o pauza in scris, si scrie DOAR ciorne. Nu e un
// detaliu: cronul publica tot ce e `programat` cu ora trecuta, deci un status
// gresit scris din salvarea automata ar trimite pe retea o postare neterminata.
//
// Grupul deschis sta in adresa (?grup=...), ca dupa F5 sa se reia exact de unde
// ai ramas. Iese din adresa cand pleci din ecran sau cand arunci grupul.
// ============================================================
const PAUZA_SALVARE_MS = 1500;

// Campurile pe care le scrie compozitorul, in ordine fixa. Proiectia unui rand
// citit din baza si a unuia construit din ecran se pot compara: asa stim daca un
// card programat sau trimis la aprobare s-a schimbat de cand a plecat (Pasul 5).
// Numele clientului nu intra: se poate schimba in fisa lui fara ca postarea sa se
// schimbe.
const CAMPURI_RAND = [
  'client_id', 'retea', 'format', 'text', 'hashtags', 'prim_comentariu', 'muta_hashtaguri',
  'imagine_url', 'imagini_url', 'video_url',
  'coperta_url', 'coperta_ms',
  'link_url', 'link_titlu', 'link_descriere', 'link_imagine_url',
  'data_programata', 'ora_programata',
  'tiktok_privacy_level', 'tiktok_disable_comment', 'tiktok_disable_duet', 'tiktok_disable_stitch',
  'tiktok_brand_content_toggle', 'tiktok_brand_organic_toggle',
  'tiktok_titlu',
];

function proiectie(rand) {
  return JSON.stringify(CAMPURI_RAND.map(camp => {
    let val = rand[camp];
    if (val === undefined) val = null;
    if (camp === 'ora_programata' && val) val = String(val).slice(0, 5);
    if (camp === 'text' && val === null) val = '';
    if (camp === 'imagini_url' && Array.isArray(val) && !val.length) val = null;
    return val;
  }));
}
const FORMA_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function grupDinAdresa() {
  try {
    const grup = new URLSearchParams(window.location.search).get('grup');
    return grup && FORMA_UUID.test(grup) ? grup : null;
  } catch (_e) {
    return null;
  }
}

// Postarea de aratat, venita dintr-o alerta (?postare=): se citeste o data si se scoate din adresa.
function postareDinAdresa() {
  try {
    const adresa = new URL(window.location.href);
    const p = adresa.searchParams.get('postare');
    if (!p) return null;
    adresa.searchParams.delete('postare');
    window.history.replaceState(window.history.state, '', adresa.pathname + adresa.search + adresa.hash);
    return FORMA_UUID.test(p) ? p : null;
  } catch (_e) {
    return null;
  }
}

function scrieGrupInAdresa(grup) {
  const adresa = new URL(window.location.href);
  if (grup) adresa.searchParams.set('grup', grup);
  else adresa.searchParams.delete('grup');
  window.history.replaceState(window.history.state, '', adresa.pathname + adresa.search + adresa.hash);
}

// Media din baza are doar adresa. La redeschidere o masuram din nou, ca
// avertismentele sa spuna dupa F5 exact ce spuneau inainte.
let contorReluare = 0;
async function elementDinAdresa(url, tip) {
  contorReluare += 1;
  let nume = tip;
  try { nume = decodeURIComponent(String(url).split('/').pop().split('?')[0]) || tip; } catch (_e) { /* ramane tipul */ }
  const baza = {
    id: `r${Date.now()}_${contorReluare}`, tip, nume, url, cale: null, previzualizare: url,
    convertit: false, eroare: null, latime: 0, inaltime: 0, raport: 0, durataSec: 0, marimeMB: 0,
  };
  if (tip === 'imagine') {
    try {
      const blob = await fetch(url).then(r => r.blob());
      const masuri = await masoaraImagine(blob);
      return { ...baza, ...masuri, marimeMB: blob.size / (1024 * 1024) };
    } catch (_e) {
      return baza;
    }
  }
  // Un video care nu sta in depozitul nostru a venit prin link.
  const esteLink = !String(url).includes('/storage/v1/object/public/');
  try {
    const m = await masoaraVideoDeLaDistanta(url);
    return {
      ...baza, esteLink, durataSec: m.durataSec, latime: m.latime, inaltime: m.inaltime,
      raport: m.inaltime ? m.latime / m.inaltime : 0, marimeMB: m.marimeMB,
      masurat: !!(m.latime && m.inaltime),
    };
  } catch (_e) {
    return { ...baza, esteLink, masurat: false };
  }
}

// Ce media pleaca in coloanele postarii. Doar ce a urcat: un fisier inca in
// drum n-are adresa, iar unul picat n-are ce cauta in baza.
function mediaInCampuri(cheie, elemente) {
  const urcate = elemente.filter(x => x.url && !x.eroare);
  const poze = urcate.filter(x => x.tip === 'imagine').map(x => x.url);
  const video = urcate.find(x => x.tip === 'video');
  return {
    // imagine_url ramane PRIMA poza, ca ecranele vechi (Calendar, Aprobare,
    // Drafturi) sa arate ceva.
    imagine_url: poze[0] || null,
    imagini_url: (poze.length > 1 || cheie === 'instagram|Carusel') ? poze : null,
    video_url: video ? video.url : null,
  };
}

// Coperta, in coloanele postarii. Se scrie doar ce reteaua stie sa ia: o poza pe
// un card de TikTok n-ar pleca nicaieri, iar o secunda pe un card de Facebook la
// fel. Cardul spune asta si pe ecran, cu un avertisment. Precedenta (poza inainte
// de secunda) o aplica functiile de publicare, nu ecranul: asa raman amandoua in
// baza si se pot schimba fara sa se piarda cealalta.
function copertaInCampuri(cheie, coperta) {
  const c = coperta || {};
  const feluri = feluriCoperta(cheie);
  const url = (c.url && !c.eroare) ? c.url : null;
  return {
    coperta_url: feluri.poza ? url : null,
    coperta_ms: (feluri.secunda && Number.isFinite(c.ms)) ? Math.round(c.ms) : null,
  };
}

// ---- Publicarea pe loc (Faza 6, Pasul 6) ----

// Aceleasi functii ca in compozitorul vechi (FUNCTIE_PUBLICARE din App.js). Copie
// intentionata, ca la CANALE: cele doua compozitoare nu se importa unul pe altul.
const FUNCTIE_PUBLICARE_V2 = {
  facebook: 'facebook-publish',
  instagram: 'instagram-publish',
  tiktok: 'tiktok-publish',
  linkedin: 'linkedin-publish',
  threads: 'threads-publish',
  x: 'x-publish',
};

// Motivul unui esec, pe intelesul omului (Pasul 6, finisat la cererea Luminitei).
//
// `functions.invoke` pune corpul raspunsului in `error.context`; fara sa-l citim,
// omul ar vedea doar „non-2xx status code". Din corp luam codul nostru (ex.
// `no_token`) si, unde reteaua a trimis unul, DOAR mesajul ei pentru utilizator
// (`error_user_msg` / `message` la Meta), nu tot obiectul tehnic. Prima varianta
// arata JSON-ul intreg, cu `fbtrace_id` si coduri, pe card.

// Mesajul retelei, scos din detaliu: obiect, text JSON (uneori taiat) sau text simplu.
function mesajRetea(detaliu) {
  if (detaliu === null || detaliu === undefined || detaliu === '') return null;
  if (typeof detaliu === 'object') {
    const e = detaliu.error && typeof detaliu.error === 'object' ? detaliu.error : detaliu;
    const mesaj = e.error_user_msg || e.message || e.error_description;
    return mesaj ? String(mesaj).slice(0, 200) : null;
  }
  const text = String(detaliu);
  const gasit = text.match(/"(?:error_user_msg|message)"\s*:\s*"([^"]{1,200})"/);
  if (gasit) return gasit[1];
  return text.slice(0, 200);
}

// Chei literale, ca verificarea programatica a traducerilor sa le gaseasca.
function textMotiv(cod, retea, mesaj) {
  if (cod === 'no_token') return t('compozitor2', 'motivFaraCont', { retea });
  // Reteaua a primit textul nou, dar baza nu (editarea dupa publicare).
  if (cod === 'baza_neactualizata') return t('compozitor2', 'editareBazaNeactualizata', { retea });
  if (cod === 'linkedin_token_expirat' || cod === 'refresh_failed' || cod === 'x_token_expirat') return t('compozitor2', 'motivContExpirat', { retea });
  if (cod === 'tiktok_fara_confidentialitate') return t('compozitor2', 'lipsaTiktokConfid');
  if (cod === 'tiktok_needs_media' || cod === 'instagram_needs_media' || cod === 'reel_fara_video') {
    return t('compozitor2', 'motivFaraMediaRetea', { retea });
  }
  if (cod === 'video_fetch_failed' || cod === 'video_gol') return t('compozitor2', 'motivVideoNedescarcat');
  if (cod === 'video_procesare_esuata') return t('compozitor2', 'motivVideoProcesare', { retea });
  // Lacatul publicarii (22 octombrie 2026, facebook-publish).
  if (cod === 'deja_in_publicare') return t('compozitor2', 'motivDejaInPublicare', { retea });
  if (cod === 'deja_publicat') return t('compozitor2', 'motivDejaPublicat', { retea });
  if (cod === 'publicare_intrerupta') return t('compozitor2', 'motivPublicareIntrerupta', { retea });
  if (cod === 'ig_container_timeout' || cod === 'ig_container_error') return t('compozitor2', 'motivInstagramProcesare');
  if (cod === 'tiktok_publicare_esuata') {
    if (mesaj === 'picture_size_check_failed') return t('compozitor2', 'motivTiktokPozeMari');
    return t('compozitor2', 'motivTiktokRespins', { mesaj: mesaj || 'FAILED' });
  }
  if (mesaj) return t('compozitor2', 'motivRetea', { retea, mesaj });
  return t('compozitor2', 'motivNecunoscut', { cod: cod || '-' });
}

async function motivEroare(err, data, cheie) {
  const retea = numeCanal(String(cheie).split('|')[0]);
  let corp = data && data.error ? data : null;
  const raspuns = err && err.context;
  if (!corp && raspuns && typeof raspuns.json === 'function') {
    try { corp = await raspuns.json(); } catch (_e) { corp = null; }
  }
  if (corp && (corp.error || corp.detail)) return textMotiv(corp.error, retea, mesajRetea(corp.detail));
  return t('compozitor2', 'motivNecunoscut', { cod: (err && err.message) || '-' });
}

// Unde se vede postarea publicata. Doar unde ID-ul duce sigur la ea: Instagram si
// TikTok intorc ID-uri din care nu se poate face o adresa fara alta cerere, iar un
// Story de Facebook dispare oricum dupa 24 de ore.
function linkPostare(cheie, id) {
  if (!id) return null;
  const [canal, format] = cheie.split('|');
  if (canal === 'facebook') {
    if (format === 'Story') return null;
    return format === 'Reel' ? `https://www.facebook.com/reel/${id}` : `https://www.facebook.com/${id}`;
  }
  if (canal === 'linkedin') return `https://www.linkedin.com/feed/update/${id}`;
  if (canal === 'x') return `https://x.com/i/status/${id}`;
  // Threads intoarce id-ul postarii, nu adresa; adresa cere o a doua cerere
  // (`permalink`), deci deocamdata nu punem link, ca la Instagram si TikTok.
  return null;
}

// ---- Trimiterea la client pe WhatsApp, cu link de aprobare (19 octombrie 2026) ----
//
// Inlocuieste mesajul din 15 septembrie (reteaua si textul fiecarei postari, fara link):
// acum pleaca un link catre pagina clientului, unde vede postarile intregi, cu poze si
// filme, si raspunde cu Aprob / Modific textul / Cer schimbari (APROBARE_CLIENT_PLAN.md).
// Textul e hotararea 7 din §8. Mesajul e in ROMANA indiferent de limba interfetei: il
// citeste clientul. Pleaca din WhatsApp-ul omului din agentie, fara API platit.
function mesajLinkWhatsApp(n, link) {
  return n === 1 ? `Alertă – Ai de aprobat 1 postare: ${link}` : `Alertă – Ai de aprobat ${n} postări: ${link}`;
}

export default function CompozitorV2({ clienti = [], clientPreSelectat = null, sesiune = null, profilUtilizator = null, setPostari = null, normalizeaza = null, permisiuniClient = null }) {
  // Clientul ales din meniu vine preselectat, dar lista ramane intreaga (decizia
  // Luminitei). Cand se redeschide un grup salvat (?grup=), clientul il pune grupul.
  const [clientId, setClientId] = useState(() => (
    clientPreSelectat && !grupDinAdresa() ? String(clientPreSelectat) : ''
  ));
  // Materialul de pornire, in cinci feluri. `text` e folosit si ca text propriu-zis
  // (Text, Voce), si ca lamurire de langa poza sau document, exact ca in NM Write.
  const [intrare, setIntrare] = useState({
    fel: 'text', text: '', link: '', linkCitit: null, foto: null, doc: null,
  });
  const [alese, setAlese] = useState([]);
  const [texte, setTexte] = useState({});
  // Linkul postarii, per card. Deocamdata traieste doar in ecran: V2 nu scrie
  // inca in baza, asta e Faza 6. Cand se face, se salveaza in coloanele
  // `link_url`, `link_titlu`, `link_descriere`, `link_imagine_url`, care exista
  // deja si sunt folosite de `linkedin-publish`.
  const [linkuri, setLinkuri] = useState({});
  const [comentarii, setComentarii] = useState({});
  // Titlul cardului de TikTok Photo Mode, pe cheie ca restul, desi azi il are un singur card.
  const [titluri, setTitluri] = useState({});
  const [mutaHash, setMutaHash] = useState({});
  const [tt, setTt] = useState(TIKTOK_GOL);
  // Media comuna se aplica peste tot. Un card care are lista proprie o
  // suprascrie, si revine la comuna cu „↺".
  const [mediaComuna, setMediaComuna] = useState([]);
  const [mediaCard, setMediaCard] = useState({});
  // Coperta filmului, cu aceeasi mostenire ca media: una comuna, pe care cardul
  // o poate suprascrie. Diferenta fata de media: aici „cardul are a lui" NU se
  // vede din lungimea listei, fiindca valoarea proprie poate fi chiar `null`
  // („pe cardul asta, fara coperta"). De aia contorul e prezenta cheii.
  const [copertaComuna, setCopertaComuna] = useState(null);
  const [copertaCard, setCopertaCard] = useState({});
  const [lupa, setLupa] = useState(null);
  // Motorul de texte, legat pe 16 septembrie 2026 (functia `genereaza-texte`,
  // FAZA7_PLAN.md, pasul 4). Nota spune rezultatul: carduri, timp, cost, exemple.
  const [seGenereaza, setSeGenereaza] = useState(false);
  const [notaGenerare, setNotaGenerare] = useState(null); // { fel: 'ok' | 'eroare', text }
  const [sePotriveste, setSePotriveste] = useState({});
  // conturi[canal] = { nume: [...], eroare: string|null }. null cat timp nu stim.
  const [conturi, setConturi] = useState(null);
  // Salvarea (Faza 6). Vezi comentariul de deasupra lui `grupDinAdresa`.
  const [grupId, setGrupId] = useState(() => grupDinAdresa());
  const [seReia, setSeReia] = useState(() => !!grupDinAdresa());
  // Grupul si in ref: butoanele asteapta o salvare in curs, iar dupa ea closure-ul
  // lor inca vede grupul vechi (null). Fara ref, ar scrie randurile sub un grup nou.
  const grupRef = useRef(grupId);
  // Statusul fiecarui card in baza (Pasul 5), si ce s-a scris ultima data pe el.
  const [stariRand, setStariRand] = useState({});
  const stariRef = useRef({});
  const ultimeRanduri = useRef({});
  const [seTrimite, setSeTrimite] = useState(false);
  // Rezultatul publicarii pe loc, per card: sePublica | publicat | eroare (Pasul 6).
  const [rezultate, setRezultate] = useState({});
  const [salvare, setSalvare] = useState({ stare: 'nimic' });
  const [reluare, setReluare] = useState(0);
  const idRand = useRef({});
  const ultimaSemnatura = useRef('');
  const semnaturaEsuata = useRef('');
  const inCurs = useRef(false);
  // Ce a citit panoul TikTok despre cont. Vine prin `onInfo`.
  const [infoTikTok, setInfoTikTok] = useState({ info: null, eroare: '', incarca: false });
  // Data si ora fiecarui card (Faza 6, Pasul 4). Pornesc GOALE: decizia Luminitei,
  // fara ora implicita. Ora de 10:00 pusa din oficiu a mintit calendarul luni de zile.
  const [programari, setProgramari] = useState({});
  const [notaActiune, setNotaActiune] = useState('');
  // Ultimul link de aprobare trimis clientului pentru grupul acesta (functia `aprobare-link`,
  // `stare`): { viu, expira_la, anulat_la, postare_ids } sau null.
  const [linkClient, setLinkClient] = useState(null);
  // Postarile modificate de client prin link si inca nerepuse in fata lui:
  // { [postare_id]: { text_vechi, la } }. Din `istoric_aprobare` (pasul 7).
  const [modificari, setModificari] = useState({});
  // Cartonul la care duce alerta din clopotel, si cel luminat o clipa dupa.
  const [postareDeAratat, setPostareDeAratat] = useState(() => postareDinAdresa());
  const [luminat, setLuminat] = useState(null);
  const [propusDeschis, setPropusDeschis] = useState({});

  // Durata videoului de pe cardul de TikTok Video, pentru limita contului.
  function durataVideoTikTok() {
    const video = mediaEfectiva('tiktok|Video').find(x => x.tip === 'video');
    return video ? video.durataSec || 0 : 0;
  }

  // Cate caractere pleaca din postare in comentariu. Se socoteste din aceeasi
  // functie ca publicarea, ca sa nu ajunga contorul sa spuna altceva decat
  // ce se trimite.
  function caractereMutate(cheie) {
    if (!mutaHash[cheie]) return 0;
    const brut = texte[cheie] || '';
    const { postare } = textePublicate(cheie, brut, comentarii[cheie], true);
    return brut.length - postare.length;
  }

  const clientAles = clienti.find(c => String(c.id) === String(clientId));
  const carduri = ORDINE.filter(k => alese.includes(k));

  // Ce mai lipseste ca sa se poata genera. Lista, nu un simplu „nu se poate":
  // un buton stins fara motiv e cel mai enervant lucru dintr-o interfata.
  // Materialul se socoteste dupa felul ales, fiindca la Foto si la Doc textul e
  // doar o lamurire optionala, nu materialul propriu-zis.
  const areMaterial = (() => {
    if (intrare.fel === 'foto') return !!intrare.foto;
    if (intrare.fel === 'doc') return !!intrare.doc;
    if (intrare.fel === 'link') return !!intrare.linkCitit;
    return !!intrare.text.trim();
  })();
  const lipsuri = [
    ...(clientId ? [] : ['lipsaClient']),
    ...(carduri.length ? [] : ['lipsaFormate']),
    ...(areMaterial ? [] : ['lipsaMaterial']),
  ];
  const poateGenera = lipsuri.length === 0;

  // Ce conturi are clientul, pe fiecare canal. Fara asta poti bifa Instagram
  // pentru un client care n-are Instagram conectat si construiesti linistit un
  // card care n-are unde sa plece — afli abia la publicare.
  useEffect(() => {
    let activ = true;
    setConturi(null);
    if (!clientId) return undefined;
    (async () => {
      // O singura cerere pentru toate canalele (16 septembrie 2026, Etapa 4,
      // pasul 7). Inainte erau patru, cate una pe canal, si nu aduceau poza.
      // `conturi_client` intoarce numele, poza si starea, si verifica cine intreaba.
      const rezultat = {};
      CANALE.forEach(c => { rezultat[c.id] = { nume: [], poza: null, eroare: null }; });

      const { data, error } = await supabase.rpc('conturi_client', {
        p_client_id: Number(clientId),
      });
      if (!activ) return;

      // Eroarea se intoarce ca mesaj, nu ca lista goala: altfel un canal
      // conectat ar aparea "neconectat" si nimeni n-ar sti de ce.
      if (error) {
        CANALE.forEach(c => { rezultat[c.id].eroare = error.message; });
      } else {
        (data || []).forEach(r => {
          if (!rezultat[r.platform]) return;
          if (r.nume) rezultat[r.platform].nume.push(r.nume);
          if (r.poza_url) rezultat[r.platform].poza = r.poza_url;
        });
      }
      if (!activ) return;
      setConturi(rezultat);
      // Cartoanele de pe retele neconectate RAMAN (decizia Luminitei, 16 septembrie
      // 2026). Pana atunci erau scoase aici, deci un grup redeschis la un client
      // fara conturi aparea gol. Lipsa contului blocheaza doar programarea si publicarea.
    })();
    return () => { activ = false; };
  }, [clientId]);

  // ---- Motorul de texte (FAZA7_PLAN.md, pasul 4) ----
  // Scrie textele cardurilor alese, din material, in vocea clientului. Textele intra
  // ca CIORNE: salvarea automata le pune in baza, nimic nu pleaca singur.
  async function genereaza() {
    if (!poateGenera || seGenereaza) return;

    // Nu se sterge pe tacute ce a scris omul.
    const cuText = carduri.filter(k => (texte[k] || '').trim());
    if (cuText.length && !window.confirm(t('compozitor2', 'genConfirmSuprascrie'))) return;

    // La server pleaca doar ce trebuie: previzualizarea pozei e o adresa locala.
    const material = { fel: intrare.fel, text: intrare.text || '' };
    if (intrare.fel === 'link' && intrare.linkCitit) {
      material.linkCitit = {
        titlu: intrare.linkCitit.titlu,
        text: intrare.linkCitit.text,
        adresa: intrare.linkCitit.adresa,
      };
    }
    if (intrare.fel === 'foto' && intrare.foto) material.foto = { date: intrare.foto.date };
    if (intrare.fel === 'doc' && intrare.doc) {
      material.doc = {
        nume: intrare.doc.nume,
        fel: intrare.doc.fel,
        date: intrare.doc.date,
        text: intrare.doc.text,
      };
    }

    // UN SINGUR FILM, nu trei (decizia Luminitei, 18 septembrie 2026): clientul
    // filmeaza o data si urca acelasi film pe Facebook, Instagram si TikTok. Deci
    // daca sunt bifate mai multe carduri de script, se cere UNUL de la motor si se
    // pune in toate. Costa o generare in loc de trei si nu mai ies trei texte
    // usor diferite pentru acelasi film. Cardurile raman separate: daca vrea
    // altceva pe TikTok, editeaza acolo.
    const carduriDeCerut = carduri.filter((k, i) => !esteScript(k) || carduri.findIndex(esteScript) === i);

    setSeGenereaza(true);
    setNotaGenerare(null);
    try {
      const { data, error } = await supabase.functions.invoke('genereaza-texte', {
        body: { client_id: Number(clientId), carduri: carduriDeCerut, intrare: material },
      });

      let rezultat = data;
      if (error) {
        // Un raspuns care nu e 2xx vine ca eroare; codul nostru sta in corpul lui.
        try { rezultat = await error.context.json(); } catch (_e) { rezultat = null; }
      }

      if (!rezultat || !rezultat.ok) {
        const MESAJE = {
          refuz: 'genErRefuz',
          fara_permisiune_ai: 'genErPermisiune',
          lipseste_materialul: 'genErMaterial',
          niciun_card_cu_text: 'genErFaraText',
          document_prea_mare: 'genErPreaMare',
          poza_prea_mare: 'genErPreaMare',
          raspuns_prea_lung: 'genErPreaLung',
        };
        const cod = rezultat && rezultat.error;
        setNotaGenerare({ fel: 'eroare', text: t('compozitor2', MESAJE[cod] || 'genErGeneral') });
        return;
      }

      const r = rezultat.rezultate || {};
      // Scriptul generat o data intra in toate cardurile de script bifate.
      const cheieScript = Object.keys(r).find(esteScript);
      setTexte(prev => {
        const nou = { ...prev };
        Object.keys(r).forEach(k => { nou[k] = r[k].text; });
        if (cheieScript) carduri.filter(esteScript).forEach(k => { nou[k] = r[cheieScript].text; });
        return nou;
      });
      // Primul comentariu se inlocuieste odata cu textul, ca sa nu ramana unul vechi
      // langa un text nou. Cardurile de lucru n-au prim comentariu.
      setComentarii(prev => {
        const nou = { ...prev };
        Object.keys(r).forEach(k => {
          if (!nuSePublica(k)) nou[k] = r[k].prim_comentariu || '';
        });
        return nou;
      });

      const lei = rezultat.cost ? Number(rezultat.cost.ron).toFixed(2) : '—';
      setNotaGenerare({
        fel: 'ok',
        text: t('compozitor2', 'genGata', { n: Object.keys(r).length, s: rezultat.secunde ?? '—', lei })
          + (rezultat.exemple
            ? t('compozitor2', 'genExemple', { e: rezultat.exemple })
            : t('compozitor2', 'genFaraExemple')),
      });
    } catch (e) {
      setNotaGenerare({ fel: 'eroare', text: t('compozitor2', 'genErGeneral') });
    } finally {
      setSeGenereaza(false);
    }
  }

  function stareCanal(id) {
    if (!clientId) return { disponibil: false, motiv: 'faraClient' };
    if (!conturi) return { disponibil: false, motiv: 'seVerifica' };
    const s = conturi[id];
    if (s && s.eroare) return { disponibil: true, motiv: 'eroare', eroare: s.eroare };
    // `poza` trece mai departe, altfel pozele conturilor n-ar ajunge niciodata
    // pe ecran: sunt incarcate, dar citite de nimeni (Etapa 4, pasul 7).
    if (s && s.nume.length > 0) return { disponibil: true, motiv: null, nume: s.nume, poza: s.poza };
    return { disponibil: false, motiv: 'neconectat' };
  }

  function puneStari(noi) {
    stariRef.current = { ...stariRef.current, ...noi };
    setStariRand({ ...stariRef.current });
  }

  function comuta(cheie) {
    const scos = alese.includes(cheie);
    const stare = stariRef.current[cheie] || 'draft';
    // Un card programat sau trimis la aprobare nu dispare pe tacute: scos de pe
    // ecran, ar fi ramas programat in baza si ar fi plecat oricum.
    if (scos && idRand.current[cheie] && (stare === 'programat' || stare === 'aprobare_finala')
      && !window.confirm(t('compozitor2', 'scoateNepublicatConfirma'))) {
      return;
    }
    setAlese(prev => (prev.includes(cheie) ? prev.filter(k => k !== cheie) : [...prev, cheie]));
    if (scos && idRand.current[cheie]) stergeRand(cheie);
  }

  // Cardul scos de pe ecran isi pierde si randul din baza, oricare ar fi statusul
  // lui, IN AFARA de publicat: o postare deja publicata ramane in istoric.
  async function stergeRand(cheie) {
    const id = idRand.current[cheie];
    delete idRand.current[cheie];
    delete ultimeRanduri.current[cheie];
    if ((stariRef.current[cheie] || 'draft') === 'publicat') return;
    const { data, error } = await supabase.from('postari').delete().eq('id', id).neq('status', 'publicat').select('id');
    if (error) {
      idRand.current[cheie] = id;
      setSalvare({ stare: 'eroare', mesaj: error.message });
      return;
    }
    const stari = { ...stariRef.current };
    delete stari[cheie];
    stariRef.current = stari;
    setStariRand(stari);
    if (data && data.length && setPostari) setPostari(prev => prev.filter(p => p.id !== id));
  }

  // Ce media are efectiv cardul: a lui, daca are; altfel cea comuna.
  //
  // „Are a lui" se citeste din PREZENTA cheii, nu din cat e in ea. O lista goala
  // pusa dinadins inseamna „pe cardul asta, nimic", nu „cardul n-a fost atins".
  //
  // Prima varianta se uita la lungime, si de aici un defect gasit de Luminita pe
  // 19 septembrie 2026: stergeai singurul fisier de pe un card de LinkedIn sau
  // TikTok, cardul ramanea cu lista goala, mostenirea zicea „gol = neatins" si
  // aducea inapoi media comuna in aceeasi clipa. Parea ca butonul de sters nu
  // face nimic, desi stergerea chiar se facuse. Nu era al retelei: se intampla
  // pe ORICE card, doar ca se vede numai la ultimul fisier.
  function mediaEfectiva(cheie) {
    return mediaCard[cheie] !== undefined ? mediaCard[cheie] : mediaComuna;
  }
  function areMediaProprie(cheie) {
    return mediaCard[cheie] !== undefined;
  }

  // Cardul mosteneste media comuna PANA il atingi. La prima atingere isi copiaza
  // comuna la el si abia apoi aplica schimbarea ceruta. Adica „+" pe un card
  // inseamna „comuna PLUS ce am pus acum", nu „doar ce am pus acum", iar „×" pe o
  // poza mostenita o scoate de pe cardul ala, fara sa atinga bara de sus.
  function pune(destinatie, transforma) {
    if (destinatie === null) { setMediaComuna(transforma); return; }
    setMediaCard(prev => {
      // Aceeasi regula ca in `mediaEfectiva`: cheia lipsa inseamna „mosteneste",
      // lista goala inseamna „gol, dinadins". Daca s-ar cauta lungimea aici, un
      // fisier adaugat pe un card golit ar readuce si media comuna cu el.
      const pornire = prev[destinatie] !== undefined ? prev[destinatie] : mediaComuna;
      return { ...prev, [destinatie]: transforma(pornire) };
    });
  }

  // Fisierele apar pe ecran imediat, cu previzualizare locala, si urca in fundal.
  // Cine pica ramane in lista, marcat, in loc sa dispara in tacere: altfel omul
  // crede ca a pus poza si afla abia la publicare ca nu era acolo.
  async function adaugaFisiere(lista, destinatie) {
    const fisiere = Array.from(lista || []);
    if (!fisiere.length || !clientId) return;
    const pregatite = (await Promise.all(fisiere.map(f => pregatesteFisier(clientId, f)))).filter(Boolean);
    if (!pregatite.length) return;
    pune(destinatie, prev => [...prev, ...pregatite]);
    for (const el of pregatite) {
      const urcat = await urcaElement(clientId, el);
      pune(destinatie, prev => prev.map(x => (x.id === urcat.id ? urcat : x)));
    }
  }

  // Adauga un video prin link, fara nicio urcare.
  //
  // Nu cere client ales, spre deosebire de fisiere: fisierele au nevoie de un
  // client ca sa stie in ce dosar sa urce, linkul nu urca nicaieri.
  async function adaugaLink(destinatie) {
    const brut = window.prompt(t('compozitor2', 'cereLink'));
    if (!brut || !brut.trim()) return;

    const asteptare = { id: 'w' + Date.now(), tip: 'video', nume: brut.trim().slice(0, 60),
      url: null, previzualizare: null, esteLink: true, eroare: null, masurat: false,
      latime: 0, inaltime: 0, raport: 0, durataSec: 0, marimeMB: 0 };
    pune(destinatie, prev => [...prev, asteptare]);

    const gata = await pregatesteLink(brut);
    if (gata.eroare) {
      // Nu lasam un element stricat in galerie: il scoatem si spunem de ce.
      pune(destinatie, prev => prev.filter(x => x.id !== asteptare.id));
      window.alert(t('compozitor2', gata.eroare === 'linkNuEVideo' ? 'linkNuEVideo' : 'linkNevalid'));
      return;
    }
    pune(destinatie, prev => prev.map(x => (x.id === asteptare.id ? gata : x)));
  }

  // Previzualizarile NU se mai elibereaza la stergere. Dupa ce cardul isi
  // copiaza media comuna, acelasi element traieste in doua liste; daca as
  // elibera adresa locala la stergerea dintr-o parte, miniatura din cealalta ar
  // ramane goala. Cateva adrese nefolosite pana la reincarcarea paginii sunt un
  // pret mult mai mic decat o poza care dispare de sub ochi.
  function stergeMedia(destinatie, id) {
    pune(destinatie, prev => prev.filter(x => x.id !== id));
  }

  function mutaMedia(destinatie, id, delta) {
    pune(destinatie, prev => {
      const i = prev.findIndex(x => x.id === id);
      const j = i + delta;
      if (i < 0 || j < 0 || j >= prev.length) return prev;
      const copie = [...prev];
      copie[i] = prev[j];
      copie[j] = prev[i];
      return copie;
    });
  }

  // „Potriveste": inlocuieste poza de pe cardul asta cu una adusa la forma
  // ceruta, fara sa taie din ea. Nu atinge bara comuna si nu atinge celelalte
  // carduri — regula de mostenire face copia singura, la prima atingere.
  async function potrivestePoza(cheie, id) {
    const el = mediaEfectiva(cheie).find(x => x.id === id);
    if (!el || el.tip !== 'imagine' || !el.url) return;
    const tinta = formaTinta(cheie, el.raport);
    if (!tinta) return;

    setSePotriveste(prev => ({ ...prev, [id]: true }));
    try {
      const sursa = await fetch(el.url).then(r => r.blob());
      const fisier = new File([sursa], el.nume, { type: sursa.type || 'image/jpeg' });
      const potrivit = await potriveste(fisier, tinta);
      const pregatit = await pregatesteFisier(clientId, potrivit);
      if (!pregatit) return;
      pune(cheie, prev => prev.map(x => (x.id === id ? pregatit : x)));
      const urcat = await urcaElement(clientId, pregatit);
      pune(cheie, prev => prev.map(x => (x.id === pregatit.id ? urcat : x)));
    } catch (err) {
      // Nu darama nimic: poza veche ramane pe card, cu avertismentul ei.
      console.error('Potrivire eșuată:', err);
    } finally {
      setSePotriveste(prev => { const c = { ...prev }; delete c[id]; return c; });
    }
  }

  function revinoLaComuna(cheie) {
    setMediaCard(prev => {
      const copie = { ...prev };
      delete copie[cheie];
      return copie;
    });
  }

  // ---- Coperta ----

  function copertaEfectiva(cheie) {
    return copertaCard[cheie] !== undefined ? copertaCard[cheie] : copertaComuna;
  }
  function areCopertaProprie(cheie) {
    return copertaCard[cheie] !== undefined;
  }
  function puneCoperta(destinatie, valoare) {
    if (destinatie === null) { setCopertaComuna(valoare); return; }
    setCopertaCard(prev => ({ ...prev, [destinatie]: valoare }));
  }
  function revinoLaCopertaComuna(cheie) {
    setCopertaCard(prev => {
      const copie = { ...prev };
      delete copie[cheie];
      return copie;
    });
  }

  // Poza de coperta trece prin ACELASI drum ca orice imagine: `pregatesteFisier`
  // o duce in JPEG pe fundal alb si o micsoreaza, `urcaElement` o urca in
  // acelasi depozit. Fara asta, un PNG cu transparenta ar ajunge coperta cu
  // fundal negru pe Instagram, exact capcana pentru care s-a scris `laJpeg`.
  //
  // Se vede pe ecran imediat, cu previzualizarea locala, si urca in fundal —
  // ca la media. Secunda deja pusa NU se pierde: raman amandoua in valoare, iar
  // precedenta (poza inainte de secunda) o aplica publicarea.
  async function urcaCoperta(lista, destinatie, msNou) {
    const fisier = Array.from(lista || [])[0];
    if (!fisier || !clientId) return;
    if (!fisier.type.startsWith('image/')) {
      window.alert(t('compozitor2', 'copertaDoarPoza'));
      return;
    }
    const veche = destinatie === null ? copertaComuna : copertaEfectiva(destinatie);
    // Secunda vine odata cu poza doar cand cadrul a fost ales din film; altfel
    // ramane cea de dinainte.
    const pastrat = {
      ms: Number.isFinite(msNou)
        ? msNou
        : ((veche && Number.isFinite(veche.ms)) ? veche.ms : null),
    };
    const pregatit = await pregatesteFisier(clientId, fisier);
    if (!pregatit) return;
    puneCoperta(destinatie, {
      ...pastrat, url: null, cale: null, nume: pregatit.nume,
      previzualizare: pregatit.previzualizare, raport: pregatit.raport,
      seIncarca: true, eroare: null,
    });
    const urcat = await urcaElement(clientId, pregatit);
    puneCoperta(destinatie, {
      ...pastrat, url: urcat.url || null, cale: urcat.cale || null, nume: urcat.nume,
      previzualizare: urcat.previzualizare, raport: urcat.raport,
      seIncarca: false, eroare: urcat.eroare || null,
    });
  }

  // Filmul cardului: blocul de coperta nu se deseneaza fara el, iar durata lui
  // e plafonul secundei.
  function videoCard(cheie) {
    return mediaEfectiva(cheie).find(x => x.tip === 'video') || null;
  }

  // ---- Ce tine un card pe loc (Faza 6, Pasul 3) ----
  //
  // O lista de motive, nu un buton stins fara explicatie: aceeasi regula ca la
  // generare. Butoanele de programare si publicare din Pasul 4 se sting dupa
  // lista asta, deci ea e SINGURUL loc unde se decide daca un card poate pleca.
  //
  // Avertismentele de media nu se repeta aici una cu una: sunt deja pe card, cu
  // rosu. Aici apare doar ca exista una care blocheaza.
  //
  // Facebook Feed si LinkedIn sunt singurele formate care pot pleca fara media,
  // deci singurele unde o postare poate fi de-a dreptul goala.
  function lipsuriCard(cheie) {
    if (nuSePublica(cheie)) return [];
    const canal = canalDin(cheie);
    const lipsuri = [];

    const stare = stareCanal(canal.id);
    if (stare.motiv === 'neconectat') lipsuri.push({ cod: 'lipsaContNeconectat', canal: canal.label });
    if (stare.motiv === 'seVerifica') lipsuri.push({ cod: 'lipsaContSeVerifica', canal: canal.label });

    const media = mediaEfectiva(cheie);
    if (media.some(x => !x.url && !x.eroare)) lipsuri.push({ cod: 'lipsaMediaSeUrca' });
    if (avertismenteMedia(cheie, media).some(m => m.fel === 'blocant')) lipsuri.push({ cod: 'lipsaMediaBlocanta' });

    const text = texte[cheie] || '';
    const limita = LIMITE[cheie];
    const lungime = cheie === 'x|Post' ? lungimePeX(text) : text.length - caractereMutate(cheie);
    if (limita && lungime > limita) {
      lipsuri.push({ cod: 'lipsaTextPreaLung', are: lungime, max: limita, canal: canal.label });
    }
    const titlu = cheie === CARD_CU_TITLU ? (titluri[cheie] || '').trim() : '';
    if (titlu.length > TITLU_TIKTOK_MAX) {
      lipsuri.push({ cod: 'lipsaTitluPreaLung', are: titlu.length, max: TITLU_TIKTOK_MAX });
    }
    const areLink = canal.id === 'linkedin' && !!((linkuri[cheie] || {}).url || '').trim();
    if ((cheie === 'facebook|Feed' || cheie === 'linkedin|Feed' || cheie === 'x|Post') && !text.trim() && !media.some(x => x.url) && !areLink) {
      lipsuri.push({ cod: 'lipsaContinut' });
    }

    if (canal.id === 'tiktok') {
      if (infoTikTok.eroare) {
        lipsuri.push({ cod: 'lipsaTiktokEroare' });
      } else if (!infoTikTok.info) {
        lipsuri.push({ cod: 'lipsaTiktokSeVerifica' });
      } else {
        // Limita de durata priveste doar filmul; la Photo Mode nu exista.
        const durata = formatDin(cheie) === 'Video' ? durataVideoTikTok() : 0;
        for (const o of opreliștiTikTok(tt, infoTikTok.info, durata)) {
          lipsuri.push(o.cod === 'faraConfid'
            ? { cod: 'lipsaTiktokConfid' }
            : { cod: 'lipsaTiktokVideoLung', max: o.max, are: o.are });
        }
      }
    }
    return lipsuri;
  }

  // Chei literale, ca verificarea programatica a traducerilor sa le gaseasca.
  function textLipsa(l) {
    if (l.cod === 'lipsaContNeconectat') return t('compozitor2', 'lipsaContNeconectat', { canal: l.canal });
    if (l.cod === 'lipsaContSeVerifica') return t('compozitor2', 'lipsaContSeVerifica', { canal: l.canal });
    if (l.cod === 'lipsaMediaSeUrca') return t('compozitor2', 'lipsaMediaSeUrca');
    if (l.cod === 'lipsaMediaBlocanta') return t('compozitor2', 'lipsaMediaBlocanta');
    if (l.cod === 'lipsaTextPreaLung' && l.canal === 'X') return t('compozitor2', 'lipsaTextPreaLungX', { are: l.are, max: l.max });
    if (l.cod === 'lipsaTextPreaLung') return t('compozitor2', 'lipsaTextPreaLung', { are: l.are, max: l.max, canal: l.canal });
    if (l.cod === 'lipsaTitluPreaLung') return t('compozitor2', 'lipsaTitluPreaLung', { are: l.are, max: l.max });
    if (l.cod === 'lipsaContinut') return t('compozitor2', 'lipsaContinut');
    if (l.cod === 'lipsaTiktokSeVerifica') return t('compozitor2', 'lipsaTiktokSeVerifica');
    if (l.cod === 'lipsaTiktokEroare') return t('compozitor2', 'lipsaTiktokEroare');
    if (l.cod === 'lipsaTiktokConfid') return t('compozitor2', 'lipsaTiktokConfid');
    if (l.cod === 'lipsaTiktokVideoLung') return t('compozitor2', 'lipsaTiktokVideoLung', { are: l.are, max: l.max });
    return l.cod;
  }

  // ---- Butoanele de plecare (Faza 6, Pasul 4) ----
  //
  // Drepturile, decise de Luminita pe 15 septembrie: super_admin si managerul pot
  // tot pe clientii lor, inclusiv publicarea pe loc si programarea; clientul, doar
  // daca are „Poate crea postari". Ce client vede managerul decide baza (RLS) si
  // functiile de publicare, nu ecranul: aici se hotaraste doar ce butoane apar.
  const rol = profilUtilizator ? profilUtilizator.rol : null;
  const poateActiona = rol === 'super_admin' || rol === 'manager'
    || (rol === 'client' && !!(permisiuniClient && permisiuniClient.poate_crea_postari));
  // Contul de client (INTERFATA_CLIENT_PLAN.md, 16 septembrie 2026): publica si programeaza
  // doar cu „poate publica" (decizia 6c; aparat si in baza si in functiile de publicare),
  // iar cartoanele trimise lui la aprobare le aproba sau le respinge de pe carton (5a).
  const esteClient = rol === 'client';
  const poatePublicaCont = !esteClient || !!(permisiuniClient && permisiuniClient.poate_publica);
  // Clientul fara „Poate folosi AI" (cerut de Luminita pe 17 septembrie 2026): nu vede
  // NIMIC din partea de generare — nici butonul, nici caseta „Ce postam" (materialul se
  // dadea doar ca sa aiba motorul din ce scrie), nici al doilea rand de formate. Randul
  // al doilea e format numai din texte de lucru — script de Reel, text de Story, titluri
  // de planse, comunicat — adica exact ce n-ar scrie niciodata de mana. Ii ramane
  // alegerea canalelor si formatele care se publica, scrise de el.
  const areAI = !esteClient || !!(permisiuniClient && permisiuniClient.poate_folosi_ai_compositor);
  const [seDecide, setSeDecide] = useState(null);

  // Editarea textului dupa publicare. Doar super_admin si managerul (decizia
  // Luminitei, 30 septembrie 2026): fara aprobarea clientului, fara sa-l anunte.
  // Functia schimba intai reteaua si abia apoi baza.
  const poateEditaPublicat = rol === 'super_admin' || rol === 'manager';
  // Se editeaza IN caseta initiala a cardului (cerut de Luminita): butonul o
  // deblocheaza, restul cardului ramane blocat. `original` e textul de dinainte,
  // pentru „Renunta". Salvarea automata nu atinge cardurile publicate, deci textul
  // din caseta ajunge in baza doar prin `editeaza-postare`, dupa Facebook.
  const [editare, setEditare] = useState(null); // { cheie, original, seSalveaza, eroare }
  const [textEditat, setTextEditat] = useState({});

  function deschideEditare(cheie) {
    setEditare({ cheie, original: texte[cheie] || '', seSalveaza: false, eroare: '' });
    setTextEditat(prev => ({ ...prev, [cheie]: false }));
  }

  function renuntaEditare() {
    if (!editare) return;
    const { cheie, original } = editare;
    setTexte(prev => ({ ...prev, [cheie]: original }));
    setEditare(null);
  }

  async function salveazaTextPublicat() {
    if (!editare) return;
    const k = editare.cheie;
    const id = idRand.current[k];
    const textBaza = texte[k] || '';
    if (textBaza === editare.original) { setEditare(null); return; }
    // Pe retea pleaca exact ce a plecat si la publicare: daca hashtagurile au fost
    // mutate in primul comentariu, ele raman in baza, dar nu intra in postare.
    const { postare: mesaj } = textePublicate(k, textBaza, comentarii[k], !!mutaHash[k]);
    if (!id || !mesaj.trim()) return;
    setEditare(e => ({ ...e, seSalveaza: true, eroare: '' }));
    const { data, error } = await supabase.functions.invoke('editeaza-postare', {
      body: { post_id: id, mesaj, text_baza: textBaza },
    });
    if (error || !data || !data.ok) {
      const motiv = await motivEroare(error, data, k);
      setEditare(e => (e ? { ...e, seSalveaza: false, eroare: motiv } : e));
      return;
    }
    setTextEditat(prev => ({ ...prev, [k]: true }));
    setEditare(null);
    if (setPostari) setPostari(prev => prev.map(p => (p.id === id ? { ...p, text: textBaza } : p)));
  }

  async function decideCard(cheie, statusNou) {
    const id = idRand.current[cheie];
    if (!id || seDecide) return;
    let feedback = null;
    if (statusNou === 'respins') {
      const motiv = window.prompt(t('compozitor2', 'motivRespingerePrompt'));
      if (motiv === null) return;
      feedback = motiv.trim() || null;
    }
    setSeDecide(cheie);
    const { data, error } = await supabase.from('postari')
      .update(statusNou === 'respins' ? { status: 'respins', feedback } : { status: 'aprobat' })
      .eq('id', id)
      .eq('status', 'aprobare_finala')
      .select('*');
    setSeDecide(null);
    if (error || !data || !data.length) {
      setNotaActiune(t('compozitor2', 'decizieNesalvata'));
      return;
    }
    puneStari({ [cheie]: statusNou });
    if (setPostari && normalizeaza) {
      const normalizat = normalizeaza(data[0]);
      setPostari(prev => prev.map(x => (x.id === normalizat.id ? normalizat : x)));
    }
    setNotaActiune(t('compozitor2', statusNou === 'respins' ? 'cardRespins' : 'cardAprobat'));
  }

  function programareCard(cheie) {
    return programari[cheie] || { data: '', ora: '' };
  }

  function schimbaProgramare(cheie, camp, valoare) {
    setProgramari(prev => ({ ...prev, [cheie]: { ...(prev[cheie] || { data: '', ora: '' }), [camp]: valoare } }));
  }

  function aceeasiPeToate(cheie) {
    const sursa = programareCard(cheie);
    setProgramari(prev => {
      const nou = { ...prev };
      carduriSalvabile.forEach(k => { nou[k] = { data: sursa.data, ora: sursa.ora }; });
      return nou;
    });
  }

  // Ce opreste programarea, peste lista de lipsuri. Ora se compara cu ceasul
  // calculatorului; cronul numara in ora Romaniei, deci cele doua coincid pentru
  // cine lucreaza din Romania.
  function motivProgramare(cheie) {
    const p = programareCard(cheie);
    if (!p.data || !p.ora) return 'motivFaraData';
    if (new Date(`${p.data}T${p.ora}:00`) <= new Date()) return 'motivInTrecut';
    return null;
  }

  function textMotivProgramare(cod) {
    if (cod === 'motivFaraData') return t('compozitor2', 'motivFaraData');
    if (cod === 'motivInTrecut') return t('compozitor2', 'motivInTrecut');
    return cod;
  }

  const nePublicat = k => (stariRand[k] || 'draft') !== 'publicat';
  const eGata = k => lipsuriCard(k).length === 0;
  // La aprobare contul neconectat nu opreste nimic: clientul aproba textul, contul se
  // leaga pana la programare (16 septembrie 2026).
  const eGataDeAprobare = k => lipsuriCard(k).every(l => l.cod === 'lipsaContNeconectat');
  const poateAprobare = k => nePublicat(k) && eGataDeAprobare(k);
  const poateProgramare = k => nePublicat(k) && eGata(k) && !motivProgramare(k);
  const poatePublicare = k => nePublicat(k) && eGata(k);

  // Azi, in ora calculatorului, pentru `min` la alegerea datei.
  const aziLocal = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

  // ---- Salvarea (Faza 6, Pasul 2) ----

  // Randul din `postari` pentru un card, din ce e pe ecran acum.
  function randPentruCard(cheie) {
    const canal = cheie.split('|')[0];
    const link = linkuri[cheie] || {};
    const media = mediaInCampuri(cheie, mediaEfectiva(cheie));
    const areLink = canal === 'linkedin' && !!(link.url || '').trim();
    const comenteaza = POATE_COMENTA.includes(cheie);
    return {
      client_id: Number(clientId),
      client_nume: clientAles ? clientAles.nume : '',
      retea: canal,
      format: formatDin(cheie),
      // Textul brut, cu hashtagurile lui. In V2 hashtagurile stau in text, deci
      // coloana veche `hashtags` ramane goala.
      text: texte[cheie] || '',
      hashtags: null,
      // Se publica imediat dupa postare (Faza 3, 16 septembrie 2026), din functiile
      // de publicare: supabase/functions/_shared/prim_comentariu.ts.
      prim_comentariu: comenteaza ? ((comentarii[cheie] || '').trim() || null) : null,
      muta_hashtaguri: comenteaza && !!mutaHash[cheie],
      ...media,
      ...copertaInCampuri(cheie, media.video_url ? copertaEfectiva(cheie) : null),
      link_url: areLink ? link.url.trim() : null,
      link_titlu: areLink ? ((link.titlu || '').trim() || null) : null,
      link_descriere: areLink ? ((link.descriere || '').trim() || null) : null,
      link_imagine_url: areLink ? media.imagine_url : null,
      // O ora fara data nu e o programare (capcana din CLAUDE.md §11): ora se scrie
      // doar impreuna cu data. Statusul ramane ciorna; programarea e un buton.
      data_programata: (programari[cheie] && programari[cheie].data) || null,
      ora_programata: (programari[cheie] && programari[cheie].data && programari[cheie].ora) || null,
      // TOATE randurile poarta campurile TikTok, nu doar cel de TikTok. Cand
      // grupul pleaca intr-o singura inserare, randurile fara ele primesc NULL,
      // nu valoarea implicita, iar coloanele `tiktok_disable_*` sunt NOT NULL:
      // baza refuza tot grupul. Gasit la proba Pasului 3 (15 sept 2026).
      // TIKTOK_GOL da exact valorile implicite din baza.
      ...campuriTikTok(canal === 'tiktok' ? tt : TIKTOK_GOL),
      // Gol = fara titlu ales: publicarea il scoate din text (_shared/titlu_tiktok.ts).
      tiktok_titlu: cheie === CARD_CU_TITLU ? ((titluri[cheie] || '').trim() || null) : null,
    };
  }

  const carduriSalvabile = carduri.filter(k => !nuSePublica(k));
  // TEXTELE DE LUCRU (script, text de Story, planse, comunicat) nu sunt postari si
  // nu devin randuri in `postari`. Pana pe 18 septembrie 2026 nu se salvau DELOC:
  // le scria AI-ul, iar la inchiderea ecranului se pierdeau. Gasit de Luminita, pe
  // un script de Reel. Acum stau in tabelul lor, `texte_lucru`, legate de acelasi
  // `grup_id` — deci se intorc odata cu grupul, dar nu intra in Ciorne, nu apar in
  // calendar si nu pot fi publicate din greseala.
  const carduriDeLucru = carduri.filter(k => nuSePublica(k));
  // Ce poate pleca din bara de jos: cardurile publicabile care n-au plecat deja.
  const carduriDeTrimis = carduriSalvabile.filter(k => (stariRand[k] || 'draft') !== 'publicat');
  const areContinut = carduriSalvabile.some(k =>
    (texte[k] || '').trim()
    || mediaEfectiva(k).some(x => x.url)
    || (linkuri[k] && (linkuri[k].url || '').trim()));
  // Ce s-ar scrie in baza. Se salveaza doar cand se schimba asta, nu la fiecare
  // randare: masurarea unei poze schimba starea, dar nu schimba nimic din baza.
  const areTexteDeLucru = carduriDeLucru.some(k => (texte[k] || '').trim());
  const semnatura = (clientId && (carduriSalvabile.length || carduriDeLucru.length) && (areContinut || areTexteDeLucru))
    ? JSON.stringify([
      carduriSalvabile.map(k => [k, randPentruCard(k)]),
      carduriDeLucru.map(k => [k, texte[k] || '']),
    ])
    : '';

  // Scrie toate cardurile. `statusNou` (cheie -> status) vine doar de la butoane.
  //
  // Un card programat sau trimis la aprobare care s-a schimbat pe ecran se
  // intoarce la ciorna (Pasul 5): cronul nu trebuie sa publice ceva ce omul inca
  // modifica, iar clientul trebuie sa aprobe exact ce pleaca. Un card publicat nu
  // se mai scrie deloc.
  async function scrieRanduri(sem, statusNou = {}) {
    if (inCurs.current) return false;
    inCurs.current = true;
    // „Se salveaza…" si ora apar doar cand chiar se scrie ceva. Un grup deja
    // publicat, redeschis, nu scrie nimic: indicatorul nu trebuie sa pretinda ca a
    // salvat o ciorna (gasit la proba Pasului 6).
    let aScris = false;
    const incepeScrierea = () => {
      if (!aScris) { aScris = true; setSalvare({ stare: 'seSalveaza' }); }
    };
    try {
      const grup = grupRef.current || grupId || window.crypto.randomUUID();
      grupRef.current = grup;
      const schimbate = [];
      const deInserat = [];
      const stariNoi = {};
      for (const k of carduriSalvabile) {
        const stareVeche = stariRef.current[k] || 'draft';
        if (stareVeche === 'publicat') continue;
        const rand = { ...randPentruCard(k), grup_id: grup };
        const semn = proiectie(rand);
        if (statusNou[k]) rand.status = statusNou[k];
        else if (stareVeche !== 'draft' && ultimeRanduri.current[k] !== semn) rand.status = 'draft';
        if (!idRand.current[k]) { deInserat.push([k, rand, semn]); continue; }
        // Nimic schimbat pe cardul asta: nu-l mai scriem.
        if (!rand.status && ultimeRanduri.current[k] === semn) continue;
        incepeScrierea();
        const { data, error } = await supabase.from('postari').update(rand).eq('id', idRand.current[k]).select().maybeSingle();
        if (error) throw error;
        // Randul nu mai exista (sters din Drafturi, de exemplu): il scriem din nou.
        if (!data) { delete idRand.current[k]; deInserat.push([k, rand, semn]); continue; }
        ultimeRanduri.current[k] = semn;
        stariNoi[k] = data.status;
        schimbate.push(data);
      }
      if (deInserat.length) {
        const noi = deInserat.map(([, rand]) => ({
          ...rand,
          status: rand.status || 'draft',
          creat_de: sesiune && sesiune.user ? sesiune.user.id : null,
          creat_de_nume: (profilUtilizator && profilUtilizator.nume) || 'Utilizator',
        }));
        incepeScrierea();
        const { data, error } = await supabase.from('postari').insert(noi).select();
        if (error) throw error;
        for (const [k, , semn] of deInserat) {
          const rand = (data || []).find(r => `${r.retea}|${r.format}` === k);
          if (rand) {
            idRand.current[k] = rand.id;
            ultimeRanduri.current[k] = semn;
            stariNoi[k] = rand.status;
            schimbate.push(rand);
          }
        }
      }
      puneStari(stariNoi);
      // Textele de lucru, in tabelul lor. Se sterg cand raman goale, ca sa nu ramana
      // urme dupa ce omul le-a golit intentionat.
      const deScris = carduriDeLucru.filter(k => (texte[k] || '').trim());
      const deSters = carduriDeLucru.filter(k => !(texte[k] || '').trim());
      if (deScris.length) {
        incepeScrierea();
        const { error: errLucru } = await supabase.from('texte_lucru').upsert(
          deScris.map(k => ({
            client_id: Number(clientId), grup_id: grup, cheie: k,
            text: texte[k], actualizat_la: new Date().toISOString(),
          })),
          { onConflict: 'grup_id,cheie' },
        );
        if (errLucru) throw errLucru;
      }
      if (deSters.length) {
        await supabase.from('texte_lucru').delete().eq('grup_id', grup).in('cheie', deSters);
      }

      if (!grupId) setGrupId(grup);
      ultimaSemnatura.current = sem;
      semnaturaEsuata.current = '';
      if (setPostari && normalizeaza && schimbate.length) {
        const normalizate = schimbate.map(normalizeaza);
        const iduri = normalizate.map(p => p.id);
        setPostari(prev => [...normalizate, ...prev.filter(p => !iduri.includes(p.id))]);
      }
      if (aScris) setSalvare({ stare: 'salvat', la: new Date() });
      return true;
    } catch (err) {
      // Nu reincercam in bucla: asteptam o schimbare pe ecran sau „Reincearca".
      semnaturaEsuata.current = sem;
      setSalvare({ stare: 'eroare', mesaj: (err && err.message) || String(err) });
      return false;
    } finally {
      inCurs.current = false;
      setReluare(n => n + 1);
    }
  }

  function salveaza(sem) {
    return scrieRanduri(sem);
  }

  // „Trimite la aprobare" si „Programeaza" (Pasul 5). Scriu intai tot ce e pe
  // ecran, apoi schimba statusul, in aceeasi scriere: pleaca exact ce se vede.
  async function trimite(status, chei) {
    const tinta = chei.filter(k => (stariRef.current[k] || 'draft') !== 'publicat');
    if (seTrimite || !tinta.length) return;
    setSeTrimite(true);
    setNotaActiune('');
    // Daca tocmai se salveaza, asteptam salvarea sa termine (cel mult 10 s).
    for (let i = 0; i < 40 && inCurs.current; i += 1) {
      await new Promise(rezolva => { setTimeout(rezolva, 250); });
    }
    const statusNou = {};
    tinta.forEach(k => { statusNou[k] = status; });
    const reusit = await scrieRanduri(semnatura, statusNou);
    if (reusit) {
      setNotaActiune(status === 'programat'
        ? t('compozitor2', 'trimisProgramare', { n: tinta.length })
        : t('compozitor2', 'trimisAprobare', { n: tinta.length }));
    }
    setSeTrimite(false);
  }

  // „Publica acum" (Pasul 6).
  //
  // Intai scrie tot ce e pe ecran si pune cardurile tinta pe ciorna: un card
  // programat nu trebuie prins si de cron in timp ce il publicam noi. Apoi
  // cardurile pleaca pe rand, fiecare prin functia retelei lui.
  //
  // Rezultatul se citeste din BAZA, nu din raspunsul functiei: dovada plecarii e
  // `external_post_id` (capcana despre `publicat_la` din CLAUDE.md §11).
  async function publica(chei) {
    const tinta = chei.filter(k => (stariRef.current[k] || 'draft') !== 'publicat');
    if (seTrimite || !tinta.length) return;
    setSeTrimite(true);
    setNotaActiune('');
    for (let i = 0; i < 40 && inCurs.current; i += 1) {
      await new Promise(rezolva => { setTimeout(rezolva, 250); });
    }
    const peCiorna = {};
    tinta.forEach(k => { peCiorna[k] = 'draft'; });
    const scris = await scrieRanduri(semnatura, peCiorna);
    if (!scris) { setSeTrimite(false); return; }

    let reusite = 0;
    for (const k of tinta) {
      const id = idRand.current[k];
      const functie = FUNCTIE_PUBLICARE_V2[k.split('|')[0]];
      if (!id || !functie) {
        setRezultate(prev => ({ ...prev, [k]: { stare: 'eroare', motiv: t('compozitor2', 'faraFunctie') } }));
        continue;
      }
      setRezultate(prev => ({ ...prev, [k]: { stare: 'sePublica' } }));
      const { data, error } = await supabase.functions.invoke(functie, { body: { post_id: id } });
      const { data: rand } = await supabase.from('postari').select('*').eq('id', id).maybeSingle();
      if (rand && rand.status === 'publicat' && rand.external_post_id) {
        reusite += 1;
        puneStari({ [k]: 'publicat' });
        // Primul comentariu pleaca imediat dupa postare, din aceeasi functie. Daca
        // pica, postarea ramane publicata (decizia Luminitei) si se spune aici.
        const comentariu = !rand.comentariu_la ? null
          : (rand.comentariu_id ? { ok: true } : { ok: false, motiv: rand.comentariu_eroare });
        setRezultate(prev => ({ ...prev, [k]: { stare: 'publicat', link: linkPostare(k, rand.external_post_id), comentariu } }));
        if (setPostari && normalizeaza) {
          const normalizat = normalizeaza(rand);
          setPostari(prev => [normalizat, ...prev.filter(p => p.id !== normalizat.id)]);
        }
      } else {
        const motiv = (error || (data && data.error)) ? await motivEroare(error, data, k) : t('compozitor2', 'faraConfirmare');
        setRezultate(prev => ({ ...prev, [k]: { stare: 'eroare', motiv } }));
        if (rand) puneStari({ [k]: rand.status || 'draft' });
      }
    }
    setNotaActiune(t('compozitor2', 'publicateDin', { n: reusite, total: tinta.length }));
    setSeTrimite(false);
  }

  // „Trimite clientului pe WhatsApp" (APROBARE_CLIENT_PLAN.md, pasul 5). Scrie intai tot ce e
  // pe ecran si pune cardurile pe „Asteapta aprobare", ca „Trimite la aprobare"; apoi cere un
  // link nou (cel vechi al grupului se anuleaza singur) si deschide WhatsApp-ul omului cu
  // mesajul, direct in conversatia clientului daca fisa lui are numarul.
  async function trimiteClientului(chei) {
    const tinta = chei.filter(k => (stariRef.current[k] || 'draft') !== 'publicat');
    if (seTrimite || !tinta.length) return;
    // Fereastra se deschide acum, la apasare: dupa asteptare browserul ar bloca-o.
    const fereastra = window.open('', '_blank');
    setSeTrimite(true);
    setNotaActiune('');
    for (let i = 0; i < 40 && inCurs.current; i += 1) {
      await new Promise(rezolva => { setTimeout(rezolva, 250); });
    }
    const statusNou = {};
    tinta.forEach(k => { statusNou[k] = 'aprobare_finala'; });
    const scris = await scrieRanduri(semnatura, statusNou);
    const ids = tinta.map(k => idRand.current[k]).filter(Boolean);
    const grup = grupRef.current || grupId;
    if (!scris || !grup || ids.length !== tinta.length) {
      if (fereastra) fereastra.close();
      setSeTrimite(false);
      return;
    }
    const { data, error } = await supabase.functions.invoke('aprobare-link', {
      body: { actiune: 'genereaza', grup_id: grup, postare_ids: ids },
    });
    if (error || !data || !data.ok || !data.link) {
      if (fereastra) fereastra.close();
      const motiv = (data && data.error) || (error && error.message) || '';
      setNotaActiune(t('compozitor2', 'linkNetrimis', { motiv }));
      setSeTrimite(false);
      return;
    }
    const tel = data.telefon_whatsapp ? String(data.telefon_whatsapp).replace(/\D/g, '') : '';
    const adresa = `https://wa.me/${tel}?text=${encodeURIComponent(mesajLinkWhatsApp(ids.length, data.link))}`;
    if (fereastra) {
      fereastra.opener = null;
      fereastra.location.href = adresa;
    } else {
      window.open(adresa, '_blank', 'noopener');
    }
    setLinkClient({ viu: true, expira_la: data.expira_la, anulat_la: null, postare_ids: ids });
    setModificari(prev => {
      const m = { ...prev };
      ids.forEach(id => { delete m[id]; });
      return m;
    });
    setNotaActiune(tel
      ? t('compozitor2', 'linkTrimisLaClient', { n: ids.length })
      : t('compozitor2', 'linkTrimisFaraNumar', { n: ids.length }));
    setSeTrimite(false);
  }

  async function anuleazaLinkul() {
    const grup = grupRef.current || grupId;
    if (!grup || seTrimite) return;
    setSeTrimite(true);
    const { data, error } = await supabase.functions.invoke('aprobare-link', { body: { actiune: 'anuleaza', grup_id: grup } });
    setSeTrimite(false);
    if (error || !data || !data.ok) {
      setNotaActiune(t('compozitor2', 'linkNeanulat'));
      return;
    }
    setLinkClient(prev => (prev ? { ...prev, viu: false, anulat_la: new Date().toISOString() } : prev));
    setNotaActiune(t('compozitor2', 'linkAnulat'));
  }

  // Modificarea clientului pe cardul acesta, cat nu e publicat (dupa publicare nu mai conteaza).
  const modificareCard = cheie => (!esteClient && idRand.current[cheie] && stariRand[cheie] !== 'publicat'
    ? modificari[idRand.current[cheie]] || null : null);

  // Cate postari din linkul viu au raspuns de la client si cate mai asteapta (dupa starea cardului:
  // „Asteapta aprobare" = n-a raspuns inca).
  const raspunsuriLink = (() => {
    if (!linkClient || !linkClient.viu) return null;
    const chei = Object.keys(idRand.current).filter(k => linkClient.postare_ids.includes(idRand.current[k]));
    if (!chei.length) return null;
    const asteapta = chei.filter(k => stariRand[k] === 'aprobare_finala').length;
    return { n: chei.length, r: chei.length - asteapta, asteapta };
  })();

  // Cardul acesta e in linkul viu trimis clientului si inca asteapta raspunsul lui?
  const eInLinkulViu = cheie => !!(linkClient && linkClient.viu && idRand.current[cheie]
    && linkClient.postare_ids.includes(idRand.current[cheie]) && stariRand[cheie] === 'aprobare_finala');

  function textStare(cheie) {
    const stare = stariRand[cheie] || 'draft';
    if (stare === 'aprobare_finala') return t('compozitor2', 'stareAprobare');
    if (stare === 'intern') return t('compozitor2', 'stareTrimisEchipa');
    if (stare === 'respins') return t('compozitor2', 'stareRespins');
    if (stare === 'aprobat') return t('compozitor2', 'stareAprobat');
    if (stare === 'publicat') return t('compozitor2', 'starePublicat');
    if (stare === 'programat') {
      const p = programareCard(cheie);
      const zi = p.data
        ? new Date(`${p.data}T00:00:00`).toLocaleDateString(getLocale(), { day: 'numeric', month: 'short' })
        : '';
      return t('compozitor2', 'stareProgramat', { data: zi, ora: p.ora || '' });
    }
    return t('compozitor2', 'ciorna');
  }

  // Salvarea automata, la o pauza.
  useEffect(() => {
    if (seReia || !semnatura) return undefined;
    if (semnatura === ultimaSemnatura.current || semnatura === semnaturaEsuata.current) return undefined;
    const ceas = setTimeout(() => { salveaza(semnatura); }, PAUZA_SALVARE_MS);
    return () => clearTimeout(ceas);
    // salveaza e recreata la fiecare randare; semnatura spune tot ce conteaza.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semnatura, seReia, reluare]);

  // Starea linkului trimis clientului, o data la deschiderea grupului (o singura cerere mica).
  useEffect(() => {
    if (seReia || !grupId || esteClient) return undefined;
    let activ = true;
    supabase.functions.invoke('aprobare-link', { body: { actiune: 'stare', grup_id: grupId } }).then(({ data }) => {
      if (activ && data && data.ok) setLinkClient(data.link);
    });
    // Ultima intamplare pe fiecare postare: daca e „modificat", cartonul arata etichetele;
    // o retrimitere („trimis") le sterge.
    supabase.from('istoric_aprobare').select('postare_id, actiune, text_vechi, la')
      .eq('grup_id', grupId).in('actiune', ['trimis', 'modificat']).order('la', { ascending: true })
      .then(({ data }) => {
        if (!activ || !data) return;
        const m = {};
        data.forEach(x => {
          if (x.actiune === 'modificat') m[x.postare_id] = { text_vechi: x.text_vechi || '', la: x.la };
          else delete m[x.postare_id];
        });
        setModificari(m);
      });
    return () => { activ = false; };
  }, [grupId, seReia, esteClient]);

  // Dupa redeschiderea grupului: ecranul merge la cartonul din alerta si il lumineaza 2,5 s.
  useEffect(() => {
    if (seReia || !postareDeAratat) return undefined;
    const cheie = Object.keys(idRand.current).find(k => idRand.current[k] === postareDeAratat);
    setPostareDeAratat(null);
    // Venit din clopotel sau din notificarea de pe telefon: alertele grupului se sting (cele din
    // clopotel sunt deja stinse; din notificare, aici se sting).
    if (!esteClient && grupId) {
      // Dupa stingere, clopotelul si cifra de pe iconita se renumara (`useAlerte` asculta evenimentul).
      supabase.from('alerte').update({ citita_la: new Date().toISOString() }).eq('grup_id', grupId).is('citita_la', null)
        .then(() => { window.dispatchEvent(new Event('nm-alerte-schimbate')); });
    }
    if (!cheie) return undefined;
    const ceas = setTimeout(() => {
      const el = document.querySelector(`[data-cheie="${cheie}"]`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setLuminat(cheie);
    }, 150);
    const stinge = setTimeout(() => setLuminat(null), 2800);
    return () => { clearTimeout(ceas); clearTimeout(stinge); };
  }, [seReia, postareDeAratat, esteClient, grupId]);

  // Grupul in adresa, ca F5 sa-l redeschida.
  useEffect(() => {
    if (!grupId) return undefined;
    scrieGrupInAdresa(grupId);
    return () => scrieGrupInAdresa(null);
  }, [grupId]);

  // Redeschiderea grupului din adresa, o singura data, la intrarea in ecran.
  useEffect(() => {
    if (!seReia || !grupId) return undefined;
    let activ = true;
    (async () => {
      const { data, error } = await supabase.from('postari').select('*').eq('grup_id', grupId).order('created_at');
      // Textele de lucru vin din tabelul lor, tot pe `grup_id` (18 septembrie 2026).
      const { data: lucru } = await supabase.from('texte_lucru').select('cheie, text').eq('grup_id', grupId);
      if (!activ) return;
      // Un grup poate avea DOAR texte de lucru — un script scris singur, fara nicio
      // postare. Atunci `postari` e gol, dar grupul exista si trebuie redeschis.
      if (!error && (!data || !data.length) && lucru && lucru.length) {
        const txtL = {};
        const cheiL = [];
        for (const r of lucru) {
          if (!ORDINE.includes(r.cheie)) continue;
          cheiL.push(r.cheie);
          txtL[r.cheie] = r.text || '';
        }
        if (cheiL.length) {
          setAlese(cheiL.slice().sort((a, b) => ORDINE.indexOf(a) - ORDINE.indexOf(b)));
          setTexte(txtL);
          setSalvare({ stare: 'salvat' });
          setSeReia(false);
          return;
        }
      }
      if (error || !data || !data.length) {
        // Grupul nu mai exista (aruncat sau sters din Drafturi): pornim de la zero.
        setGrupId(null);
        setSeReia(false);
        if (error) setSalvare({ stare: 'eroare', mesaj: error.message });
        return;
      }
      const chei = [];
      const ids = {};
      const txt = {};
      const lnk = {};
      const com = {};
      const tit = {};
      const muta = {};
      const mediaPe = {};
      const copertaPe = {};
      const prog = {};
      const stari = {};
      const ultime = {};
      let ttNou = TIKTOK_GOL;
      for (const r of data) {
        const k = `${r.retea}|${r.format}`;
        if (!ORDINE.includes(k) || ids[k]) continue;
        chei.push(k);
        ids[k] = r.id;
        stari[k] = r.status || 'draft';
        ultime[k] = proiectie(r);
        txt[k] = r.text || '';
        if (r.link_url) lnk[k] = { url: r.link_url, titlu: r.link_titlu || '', descriere: r.link_descriere || '' };
        if (r.prim_comentariu) com[k] = r.prim_comentariu;
        if (r.tiktok_titlu) tit[k] = r.tiktok_titlu;
        if (r.muta_hashtaguri) muta[k] = true;
        if (r.data_programata) {
          prog[k] = { data: r.data_programata, ora: r.ora_programata ? String(r.ora_programata).slice(0, 5) : '' };
        }
        if (r.retea === 'tiktok') {
          ttNou = {
            privacy: r.tiktok_privacy_level || '',
            comentarii: !r.tiktok_disable_comment,
            duet: !r.tiktok_disable_duet,
            stitch: !r.tiktok_disable_stitch,
            comercial: !!(r.tiktok_brand_content_toggle || r.tiktok_brand_organic_toggle),
            brandPropriu: !!r.tiktok_brand_organic_toggle,
            brandContent: !!r.tiktok_brand_content_toggle,
          };
        }
        const poze = (r.imagini_url && r.imagini_url.length) ? r.imagini_url : (r.imagine_url ? [r.imagine_url] : []);
        mediaPe[k] = [...poze.map(u => ['imagine', u]), ...(r.video_url ? [['video', r.video_url]] : [])];
        // Zero e o secunda valida (primul cadru), deci se intreaba de lipsa, nu
        // de adevar. `undefined` apare cat timp coloanele nu sunt inca in baza.
        const areMs = r.coperta_ms !== null && r.coperta_ms !== undefined;
        if (r.coperta_url || areMs) {
          copertaPe[k] = { url: r.coperta_url || null, ms: areMs ? Number(r.coperta_ms) : null };
        }
      }
      // Daca toate cardurile au exact aceeasi media, ea redevine media comuna.
      const liste = chei.map(k => JSON.stringify(mediaPe[k]));
      const comuna = chei.length > 1 && mediaPe[chei[0]].length > 0 && liste.every(l => l === liste[0]);
      const construieste = lista => Promise.all(lista.map(([tip, u]) => elementDinAdresa(u, tip)));
      let mediaC = [];
      const mediaK = {};
      if (comuna) {
        mediaC = await construieste(mediaPe[chei[0]]);
      } else {
        await Promise.all(chei.filter(k => mediaPe[k].length).map(async k => { mediaK[k] = await construieste(mediaPe[k]); }));
      }
      // Coperta se intoarce dupa aceeasi regula ca media: identica peste tot,
      // redevine comuna. Poza se masoara din nou, ca avertismentul de forma sa
      // spuna dupa F5 exact ce spunea inainte.
      const construiesteCoperta = async v => {
        if (!v) return null;
        if (!v.url) return { url: null, cale: null, ms: v.ms, previzualizare: null, raport: 0, seIncarca: false, eroare: null };
        const el = await elementDinAdresa(v.url, 'imagine');
        return {
          url: v.url, cale: null, ms: v.ms, nume: el.nume, previzualizare: v.url,
          raport: el.raport, seIncarca: false, eroare: null,
        };
      };
      const semnaturiCoperta = chei.map(k => JSON.stringify(copertaPe[k] || null));
      const copertaLaFel = chei.length > 1 && !!copertaPe[chei[0]]
        && semnaturiCoperta.every(s => s === semnaturiCoperta[0]);
      let copertaC = null;
      const copertaK = {};
      if (copertaLaFel) {
        copertaC = await construiesteCoperta(copertaPe[chei[0]]);
      } else {
        await Promise.all(chei.filter(k => copertaPe[k]).map(async k => { copertaK[k] = await construiesteCoperta(copertaPe[k]); }));
      }
      if (!activ) return;
      for (const r of (lucru || [])) {
        if (!ORDINE.includes(r.cheie) || txt[r.cheie] !== undefined) continue;
        chei.push(r.cheie);
        txt[r.cheie] = r.text || '';
      }
      chei.sort((a, b) => ORDINE.indexOf(a) - ORDINE.indexOf(b));
      idRand.current = ids;
      ultimeRanduri.current = ultime;
      stariRef.current = stari;
      setStariRand(stari);
      setClientId(String(data[0].client_id));
      setAlese(chei);
      setTexte(txt);
      setLinkuri(lnk);
      setComentarii(com);
      setTitluri(tit);
      setMutaHash(muta);
      setProgramari(prog);
      setTt(ttNou);
      setMediaComuna(mediaC);
      setMediaCard(mediaK);
      setCopertaComuna(copertaC);
      setCopertaCard(copertaK);
      setSalvare({ stare: 'salvat' });
      setSeReia(false);
    })();
    return () => { activ = false; };
    // O singura data, la intrare: grupul care se redeschide e cel din adresa.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function reincearca() {
    semnaturaEsuata.current = '';
    setReluare(n => n + 1);
  }

  function golesteEcranul() {
    idRand.current = {};
    ultimeRanduri.current = {};
    stariRef.current = {};
    setStariRand({});
    grupRef.current = null;
    ultimaSemnatura.current = '';
    semnaturaEsuata.current = '';
    setGrupId(null);
    setAlese([]);
    setTexte({});
    setLinkuri({});
    setComentarii({});
    setTitluri({});
    setMutaHash({});
    setProgramari({});
    setNotaActiune('');
    setRezultate({});
    setTt(TIKTOK_GOL);
    setMediaComuna([]);
    setMediaCard({});
    setCopertaComuna(null);
    setCopertaCard({});
    setIntrare({ fel: 'text', text: '', link: '', linkCitit: null, foto: null, doc: null });
    setNotaGenerare(null);
    setSalvare({ stare: 'nimic' });
  }

  // „Arunca": sterge tot ce nu e publicat din grup (ciorne, trimise la aprobare,
  // programate) si goleste ecranul. Ce e deja publicat ramane in istoric.
  async function arunca() {
    if (!grupId) { golesteEcranul(); return; }
    if (!window.confirm(t('compozitor2', 'aruncaConfirma'))) return;
    const { data, error } = await supabase.from('postari').delete().eq('grup_id', grupId).neq('status', 'publicat').select('id');
    if (error) { setSalvare({ stare: 'eroare', mesaj: error.message }); return; }
    await supabase.from('texte_lucru').delete().eq('grup_id', grupId);
    const sterse = (data || []).map(r => r.id);
    if (setPostari) setPostari(prev => prev.filter(p => !sterse.includes(p.id)));
    golesteEcranul();
  }

  function textSalvare() {
    if (carduriSalvabile.length && carduriSalvabile.every(k => stariRand[k] === 'publicat')) {
      return t('compozitor2', 'totulPublicat');
    }
    if (salvare.stare === 'seSalveaza') return t('compozitor2', 'seSalveaza');
    if (salvare.stare === 'eroare') return t('compozitor2', 'nuSaSalvat', { msg: salvare.mesaj });
    if (salvare.stare === 'salvat') {
      return salvare.la
        ? t('compozitor2', 'salvatLa', { ora: salvare.la.toLocaleTimeString(getLocale(), { hour: '2-digit', minute: '2-digit' }) })
        : t('compozitor2', 'salvat');
    }
    return t('compozitor2', 'nesalvat');
  }

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('compozitor2', 'titlu')}</h1>
          <p className="pagina-subtitlu">{t('compozitor2', 'subtitlu')}</p>
        </div>
      </div>

      <div className="v2-layout">
        {/* ---- Coloana din stanga: materia prima ---- */}
        <aside className="v2-rail">
          <div className="sectiune">
            <label className="label">{t('compozitor2', 'client')}</label>
            <select className="select-input" value={clientId} onChange={e => setClientId(e.target.value)}>
              <option value="">{t('compozitor2', 'selecteazaClient')}</option>
              {clienti.filter(c => c.status === 'activ').map(c => (
                <option key={c.id} value={c.id}>{c.nume}{c.functie ? ` — ${c.functie}` : ''}</option>
              ))}
            </select>
          </div>

          {/* Ordinea urmeaza cum se intampla munca: cine, ce, unde. Ai un
              eveniment, apoi decizi unde il duci. Nu invers. */}
          {areAI && (
          <div className="sectiune">
            <label className="label">{t('compozitor2', 'cePostam')}</label>
            <IntrareV2 valoare={intrare} onSchimba={setIntrare} />
            <p className="v2-hint">{t('compozitor2', 'cePostamHint')}</p>
          </div>
          )}

          <div className="sectiune">
            <label className="label">{t('compozitor2', 'undePostam')}</label>
            {CANALE.map(c => {
              // Presa n-are cont de verificat, deci nici stare: are nevoie doar de
              // un client ales, ca sa se stie in a cui voce se scrie.
              const stare = c.id === 'presa'
                ? { disponibil: !!clientId, motiv: null }
                : stareCanal(c.id);
              return (
                <div key={c.id} className={`v2-canal${stare.disponibil ? '' : ' stins'}`}>
                  <div className="v2-canal-nume">
                    <span className="v2-bulina" style={{ background: c.culoare }}>{c.mono}</span>
                    {c.label}
                    {/* Poza contului, ca sa se vada PE CE cont pleaca postarea,
                        nu doar pe ce retea (Etapa 4, pasul 7). */}
                    {stare.poza && (
                      <img
                        src={stare.poza}
                        alt=""
                        style={{ width: 18, height: 18, borderRadius: '50%', objectFit: 'cover', marginLeft: 6, verticalAlign: 'middle' }}
                      />
                    )}
                    {stare.nume && <span className="v2-cont">{stare.nume.join(', ')}</span>}
                    {stare.motiv === 'neconectat' && <span className="v2-cont neconectat">{t('compozitor2', 'neconectat')}</span>}
                    {stare.motiv === 'seVerifica' && <span className="v2-cont">{t('compozitor2', 'seVerifica')}</span>}
                  </div>
                  {stare.motiv === 'eroare' && (
                    <p className="v2-eroare">{t('compozitor2', 'nuAmVerificat', { msg: stare.eroare })}</p>
                  )}
                  {/* Doua randuri: intai formatele care se publica, sub ele cele de
                      lucru. Amestecate, ochiul nu mai distinge ce pleaca pe retea
                      de ce ramane la tine, oricat de diferit le-ai colora. */}
                  {(areAI ? ['publica', 'lucru'] : ['publica']).map(grup => {
                    const lista = c.formate.filter(f => nuSePublica(`${c.id}|${f}`) === (grup === 'lucru'));
                    if (!lista.length) return null;
                    return (
                  <div key={grup} className={`v2-formate${grup === 'lucru' ? ' v2-formate-lucru' : ''}`}>
                    {lista.map(f => {
                      const cheie = `${c.id}|${f}`;
                      const on = alese.includes(cheie);
                      return (
                        <button
                          key={f}
                          type="button"
                          className={`v2-format${on ? ' on' : ''}`}
                          style={on && !nuSePublica(cheie) ? { borderColor: c.culoare, background: c.bg, color: c.culoare } : undefined}
                          data-lucru={nuSePublica(cheie) ? '1' : undefined}
                          aria-pressed={on}
                          // Decizia Luminitei (16 septembrie 2026): cartonul se deschide
                          // si pe o retea neconectata — scrii, salvezi, trimiti la
                          // aprobare. Programarea si publicarea raman blocate de lipsa
                          // „contul nu e conectat" pana se leaga contul.
                          //
                          // Cardurile de script pot fi bifate toate (decizia Luminitei,
                          // 18 septembrie 2026): generarea e una singura si acelasi text
                          // intra in fiecare, dar cardurile raman separate si editabile.
                          disabled={!clientId}
                          onClick={() => comuta(cheie)}
                        >
                          {etichetaFormat(f)}
                        </button>
                      );
                    })}
                  </div>
                    );
                  })}
                </div>
              );
            })}
            <p className="v2-hint">
              {clientId ? t('compozitor2', 'hintFormate') : t('compozitor2', 'hintAlegeClient')}
            </p>
          </div>

          {/* Clientul fara `poate_folosi_ai_compositor` nu vede butonul: motorul
              l-ar refuza oricum (403), dar un buton care stim ca pica nu se arata. */}
          {areAI && (
          <div className="sectiune v2-generare">
            <button
              type="button"
              className="btn-principal v2-btn-genereaza"
              disabled={!poateGenera || seGenereaza}
              onClick={genereaza}
            >
              {seGenereaza ? t('compozitor2', 'seGenereaza') : t('compozitor2', 'genereaza')}
            </button>
            {!poateGenera && (
              <ul className="v2-lipsuri">
                {lipsuri.map(l => <li key={l}>{t('compozitor2', l)}</li>)}
              </ul>
            )}
            {notaGenerare && (
              <p
                className="v2-nota"
                style={{
                  marginTop: 10,
                  ...(notaGenerare.fel === 'eroare' ? { background: '#FDEDEC', borderColor: '#F3C2BC' } : {}),
                }}
              >
                {notaGenerare.fel === 'eroare' && (
                  <span className="v2-nota-eticheta">{t('compozitor2', 'genEroareTitlu')}</span>
                )}
                {notaGenerare.text}
              </p>
            )}
          </div>
          )}
        </aside>

        {/* ---- Coloana din dreapta: cardurile ---- */}
        <section className="v2-carduri">
          {carduri.length > 0 && (
            <div className="v2-bara-media">
              <div className="v2-bara-cap">
                <span className="v2-bara-titlu">{t('compozitor2', 'mediaComuna')}</span>
                <span className="v2-bara-hint">{t('compozitor2', 'mediaComunaHint')}</span>
                <button type="button" className="v2-btn-media" onClick={() => adaugaLink(null)}>
                  {t('compozitor2', 'adaugaLink')}
                </button>
                <label className="v2-btn-media">
                  <input type="file" accept="image/*,video/*" multiple style={{ display: 'none' }}
                    onChange={e => { adaugaFisiere(e.target.files, null); e.target.value = ''; }} />
                  {t('compozitor2', 'adaugaMedia')}
                </label>
              </div>
              <Galerie
                elemente={mediaComuna}
                onSterge={id => stergeMedia(null, id)}
                etichetaGoala={t('compozitor2', 'faraMediaComuna')}
                onDeschide={setLupa}
                onMuta={(id, d) => mutaMedia(null, id, d)}
              />
              {/* Coperta comuna apare doar cand are rost: un film in bara si cel
                  putin un card care stie s-o duca. */}
              {carduri.some(k => DUCE_COPERTA.includes(k)) && (
                <BlocCoperta
                  cheie={null}
                  valoare={copertaComuna}
                  video={mediaComuna.find(x => x.tip === 'video') || null}
                  dinComuna={false}
                  onPoza={(fisiere, msNou) => urcaCoperta(fisiere, null, msNou)}
                  onSchimba={val => puneCoperta(null, val)}
                  onRevino={null}
                />
              )}
            </div>
          )}

          {carduri.length === 0 ? (
            <div className="v2-gol">
              <p className="v2-gol-titlu">{t('compozitor2', seReia ? 'seRedeschide' : 'golTitlu')}</p>
              <p className="v2-gol-text">
                {!clientId ? t('compozitor2', 'golFaraClient') : t('compozitor2', 'golFaraCanale')}
              </p>
            </div>
          ) : (
            <>
              <div className="v2-numar-rand">
                <div className="v2-numar">
                  {carduri.length === 1
                    ? t('compozitor2', 'nrCarduriUnu')
                    : t('compozitor2', 'nrCarduri', { n: carduri.length })}
                </div>
                {carduriSalvabile.length > 0 && (
                  <span className="v2-gata-sumar">
                    {t('compozitor2', 'nrGata', {
                      n: carduriSalvabile.filter(k => lipsuriCard(k).length === 0).length,
                      total: carduriSalvabile.length,
                    })}
                  </span>
                )}
                <span className={`v2-salvare ${salvare.stare}`} role="status">{textSalvare()}</span>
                {salvare.stare === 'eroare' && (
                  <button type="button" className="v2-btn-media mic" onClick={reincearca}>
                    {t('compozitor2', 'reincearca')}
                  </button>
                )}
                {grupId && (
                  <button type="button" className="v2-btn-media mic v2-arunca"
                    disabled={salvare.stare === 'seSalveaza'} onClick={arunca}>
                    {t('compozitor2', 'arunca')}
                  </button>
                )}
              </div>
              {carduri.map(cheie => {
                const c = canalDin(cheie);
                const lucru = nuSePublica(cheie);
                return (
                  <article key={cheie} data-cheie={cheie} className={`v2-card${lucru ? ' v2-card-lucru' : ''}`}
                    style={luminat === cheie ? { boxShadow: '0 0 0 3px #E9C46A', transition: 'box-shadow .3s' } : { transition: 'box-shadow .6s' }}>
                    <header className="v2-card-cap" style={{ borderLeftColor: lucru ? '#B45309' : c.culoare }}>
                      <span className="v2-bulina" style={{ background: lucru ? '#B45309' : c.culoare }}>{c.mono}</span>
                      {/* Poza contului pe card: se vede PE CE cont pleaca, nu doar
                          pe ce retea (Etapa 4, pasul 7). */}
                      {stareCanal(c.id).poza && (
                        <img
                          src={stareCanal(c.id).poza}
                          alt=""
                          style={{ width: 20, height: 20, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                        />
                      )}
                      <span className="v2-card-nume">
                        <b>{c.label} · {etichetaFormat(formatDin(cheie))}</b>
                        {clientAles && <span className="v2-card-client">{clientAles.nume}</span>}
                      </span>
                      <span className={`v2-stare${lucru ? ' v2-stare-lucru' : ` v2-stare-${stariRand[cheie] || 'draft'}`}`}>
                        {lucru ? t('compozitor2', 'nuSePublica') : textStare(cheie)}
                      </span>
                      <button
                        type="button"
                        className="v2-sterge"
                        title={t('compozitor2', 'scoateCard')}
                        aria-label={t('compozitor2', 'scoateCard')}
                        onClick={() => comuta(cheie)}
                      >
                        ×
                      </button>
                    </header>
                    {!lucru && poateEditaPublicat && stariRand[cheie] === 'publicat'
                      && POATE_EDITA_PUBLICAT.includes(cheie) && idRand.current[cheie] && (
                      <div className="v2-editare-publicat" style={{ padding: '10px 16px 0' }}>
                        {editare && editare.cheie === cheie ? (
                          <>
                            <div className="v2-card-actiuni" style={{ marginTop: 0 }}>
                              <button type="button" className="btn-principal"
                                disabled={editare.seSalveaza || !(texte[cheie] || '').trim()} onClick={salveazaTextPublicat}>
                                {t('compozitor2', editare.seSalveaza ? 'editareSeSalveaza' : 'editareSalveaza')}
                              </button>
                              <button type="button" className="btn-secundar" disabled={editare.seSalveaza}
                                onClick={renuntaEditare}>
                                {t('compozitor2', 'editareRenunta')}
                              </button>
                            </div>
                            {mutaHash[cheie] && (
                              <p className="v2-rezultat-nota">{t('compozitor2', 'editareFaraComentariu')}</p>
                            )}
                            {editare.eroare && (
                              <p className="v2-rezultat eroare" role="alert">{editare.eroare}</p>
                            )}
                          </>
                        ) : (
                          <>
                            <button type="button" className="v2-btn-media mic" disabled={!!editare}
                              onClick={() => deschideEditare(cheie)}>
                              {t('compozitor2', 'editeazaTextul')}
                            </button>
                            {textEditat[cheie] && (
                              <span className="v2-rezultat-nota"> {t('compozitor2', 'textEditatOk')}</span>
                            )}
                          </>
                        )}
                      </div>
                    )}
                    {/* Caseta de text a cardului publicat care se editeaza iese din blocul
                        blocat de mai jos: un fieldset dezactivat nu lasa nimic din el activ. */}
                    {editare && editare.cheie === cheie && (
                      <div className="v2-card-corp">
                        <EditorCard
                          cheie={cheie}
                          text={texte[cheie] || ''}
                          onChange={val => setTexte(prev => ({ ...prev, [cheie]: val }))}
                          scazut={caractereMutate(cheie)}
                        />
                      </div>
                    )}
                    {/* Blocat dupa publicare (nu se mai scrie in baza) si cat timp se trimite. */}
                    <fieldset className="v2-card-fieldset" disabled={stariRand[cheie] === 'publicat' || seTrimite || (esteClient && !poateActiona)}>
                    <div className="v2-card-corp">
                      <BlocTitluTikTok
                        cheie={cheie}
                        valoare={titluri[cheie]}
                        onChange={val => setTitluri(prev => ({ ...prev, [cheie]: val }))}
                      />
                      {!(editare && editare.cheie === cheie) && modificareCard(cheie) && (
                        <EticheteModificare la={modificareCard(cheie).la} deschis={!!propusDeschis[cheie]}
                          onComuta={() => setPropusDeschis(prev => ({ ...prev, [cheie]: !prev[cheie] }))} />
                      )}
                      {!(editare && editare.cheie === cheie) && (
                      <EditorCard
                        cheie={cheie}
                        text={texte[cheie] || ''}
                        onChange={val => setTexte(prev => ({ ...prev, [cheie]: val }))}
                        scazut={caractereMutate(cheie)}
                      />
                      )}
                      {!(editare && editare.cheie === cheie) && modificareCard(cheie) && propusDeschis[cheie] && (
                        <TextPropus text={modificareCard(cheie).text_vechi} />
                      )}
                      {/* Un script sau un comunicat n-are link de previzualizare si
                          n-are prim comentariu: nu pleaca pe nicio retea. */}
                      {!lucru && (
                      <BlocLink
                        cheie={cheie}
                        valoare={linkuri[cheie]}
                        onChange={val => setLinkuri(prev => ({ ...prev, [cheie]: val }))}
                      />
                      )}
                      {!lucru && (
                      <BlocComentariu
                        cheie={cheie}
                        valoare={comentarii[cheie]}
                        onChange={val => setComentarii(prev => ({ ...prev, [cheie]: val }))}
                        mutaHash={!!mutaHash[cheie]}
                        onMutaHash={val => setMutaHash(prev => ({ ...prev, [cheie]: val }))}
                        textPostare={texte[cheie] || ''}
                      />
                      )}
                      {!lucru && POATE_COMENTA.includes(cheie) && ((comentarii[cheie] || '').trim() || mutaHash[cheie]) && (
                        <p className="v2-com-ajutor">{t('compozitor2', 'comentariuNuSePublica')}</p>
                      )}
                      {lucru && <p className="v2-card-lucru-nota">{t('compozitor2', 'lucruNota')}</p>}
                    </div>
                    {!lucru && (
                    <div className="v2-card-media">
                      <Galerie
                        elemente={mediaEfectiva(cheie)}
                        cheie={cheie}
                        onSterge={id => stergeMedia(cheie, id)}
                        etichetaGoala={t('compozitor2', 'faraMedia')}
                        onDeschide={setLupa}
                        onMuta={(id, d) => mutaMedia(cheie, id, d)}
                      />
                      <div className="v2-card-media-actiuni">
                        {!areMediaProprie(cheie) && mediaComuna.length > 0 && (
                          <span className="v2-eticheta-comuna">{t('compozitor2', 'dinComuna')}</span>
                        )}
                        <button type="button" className="v2-btn-media mic"
                          onClick={() => adaugaLink(cheie)}>
                          {t('compozitor2', 'adaugaLink')}
                        </button>
                        <label className="v2-btn-media mic">
                          <input type="file" accept="image/*,video/*" multiple style={{ display: 'none' }}
                            onChange={e => { adaugaFisiere(e.target.files, cheie); e.target.value = ''; }} />
                          {t('compozitor2', 'adaugaMedia')}
                        </label>
                        {areMediaProprie(cheie) && (
                          <button type="button" className="v2-btn-media mic"
                            onClick={() => revinoLaComuna(cheie)}>
                            {t('compozitor2', 'revinoComuna')}
                          </button>
                        )}
                      </div>
                      <BlocCoperta
                        cheie={cheie}
                        valoare={copertaEfectiva(cheie)}
                        video={videoCard(cheie)}
                        dinComuna={!areCopertaProprie(cheie) && areCoperta(copertaComuna)}
                        onPoza={(fisiere, msNou) => urcaCoperta(fisiere, cheie, msNou)}
                        onSchimba={val => puneCoperta(cheie, val)}
                        onRevino={(areCopertaProprie(cheie) && areCoperta(copertaComuna))
                          ? () => revinoLaCopertaComuna(cheie) : null}
                      />
                    </div>
                    )}
                    </fieldset>
                    {(() => {
                      if (lucru) return null;
                      const av = [
                        ...avertismenteMedia(cheie, mediaEfectiva(cheie)),
                        ...avertismenteCoperta(cheie, copertaEfectiva(cheie), mediaEfectiva(cheie)),
                      ];
                      if (!av.length) return null;
                      return (
                        <ul className="v2-avertismente">
                          {av.map((m, i) => (
                            <li key={i} className={m.fel === 'blocant' ? 'blocant' : (m.fel === 'info' ? 'info' : 'atentie')}>
                              {textAvertisment(m)}
                              {m.id && (
                                <button type="button" className="v2-btn-media mic v2-potriveste"
                                  disabled={!!sePotriveste[m.id]}
                                  onClick={() => potrivestePoza(cheie, m.id)}>
                                  {sePotriveste[m.id]
                                    ? t('compozitor2', 'sePotriveste')
                                    : t('compozitor2', 'potriveste')}
                                </button>
                              )}
                            </li>
                          ))}
                        </ul>
                      );
                    })()}
                    {!lucru && stariRand[cheie] !== 'publicat' && (
                      <div className="v2-card-plecare">
                        <label className="v2-plecare-camp">
                          <span>{t('compozitor2', 'data')}</span>
                          <input type="date" min={aziLocal} value={programareCard(cheie).data}
                            onChange={e => schimbaProgramare(cheie, 'data', e.target.value)} />
                        </label>
                        <label className="v2-plecare-camp">
                          <span>{t('compozitor2', 'ora')}</span>
                          <OraMinut value={programareCard(cheie).ora}
                            onChange={v => schimbaProgramare(cheie, 'ora', v)} />
                        </label>
                        {carduriSalvabile.length > 1 && (
                          <button type="button" className="v2-btn-media mic"
                            disabled={!programareCard(cheie).data || !programareCard(cheie).ora}
                            onClick={() => aceeasiPeToate(cheie)}>
                            {t('compozitor2', 'aceeasiPeToate')}
                          </button>
                        )}
                      </div>
                    )}
                    {!lucru && (() => {
                      const lipsuri = lipsuriCard(cheie);
                      if (!lipsuri.length) {
                        return <p className="v2-card-gata">{t('compozitor2', 'gataDePlecare')}</p>;
                      }
                      return (
                        <div className="v2-card-lipsuri">
                          <span className="v2-card-lipsuri-titlu">{t('compozitor2', 'lipsuriTitlu')}</span>
                          <ul>
                            {lipsuri.map(l => <li key={l.cod}>{textLipsa(l)}</li>)}
                          </ul>
                        </div>
                      );
                    })()}
                    {!lucru && rezultate[cheie] && (
                      <div className={`v2-rezultat ${rezultate[cheie].stare}`} role="status">
                        {rezultate[cheie].stare === 'sePublica' && t('compozitor2', 'sePublica')}
                        {rezultate[cheie].stare === 'publicat' && (
                          <>
                            {t('compozitor2', 'publicatOk')}
                            {rezultate[cheie].link && (
                              <a href={rezultate[cheie].link} target="_blank" rel="noopener noreferrer">
                                {t('compozitor2', 'veziPostarea')}
                              </a>
                            )}
                            {canalDin(cheie).id === 'tiktok' && <span className="v2-rezultat-nota">{t('compozitor2', 'tiktokPrivat')}</span>}
                            {rezultate[cheie].comentariu && (
                              <span className="v2-rezultat-nota" style={{ whiteSpace: 'pre-wrap' }}>
                                {rezultate[cheie].comentariu.ok
                                  ? t('compozitor2', 'comentariuPublicat')
                                  : t('compozitor2', 'comentariuPicat', { motiv: rezultate[cheie].comentariu.motiv || '' })}
                              </span>
                            )}
                          </>
                        )}
                        {rezultate[cheie].stare === 'eroare' && (
                          <>
                            {t('compozitor2', 'aPicat', { motiv: rezultate[cheie].motiv })}
                            {poateActiona && poatePublicaCont && (
                              <button type="button" className="v2-btn-media mic"
                                disabled={seTrimite || !poatePublicare(cheie)} onClick={() => publica([cheie])}>
                                {t('compozitor2', 'reincearcaPublicare')}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}
                    {!lucru && esteClient && stariRand[cheie] === 'aprobare_finala' && (
                      <div className="v2-card-actiuni">
                        <button type="button" className="btn-principal" disabled={!!seDecide || seTrimite} onClick={() => decideCard(cheie, 'aprobat')}>
                          {t('compozitor2', 'aproba')}
                        </button>
                        <button type="button" className="btn-secundar" disabled={!!seDecide || seTrimite} onClick={() => decideCard(cheie, 'respins')}>
                          {t('compozitor2', 'respinge')}
                        </button>
                        <span className="v2-actiuni-motiv">{t('compozitor2', 'aprobaExplicatie')}</span>
                      </div>
                    )}
                    {!lucru && poateActiona && stariRand[cheie] !== 'publicat' && !(esteClient && stariRand[cheie] === 'aprobare_finala') && (
                      <div className="v2-card-actiuni">
                        <button type="button" className="btn-secundar" disabled={!poateAprobare(cheie) || seTrimite} onClick={() => trimite(esteClient ? 'intern' : 'aprobare_finala', [cheie])}>
                          {t('compozitor2', esteClient ? 'trimiteEchipaNM' : 'trimiteAprobare')}
                        </button>
                        {poatePublicaCont && (
                        <button type="button" className="btn-secundar" disabled={!poateProgramare(cheie) || seTrimite} onClick={() => trimite('programat', [cheie])}>
                          {t('compozitor2', 'programeaza')}
                        </button>
                        )}
                        {poatePublicaCont && (
                        <button type="button" className="btn-principal" disabled={!poatePublicare(cheie) || seTrimite} onClick={() => publica([cheie])}>
                          {t('compozitor2', 'publicaAcum')}
                        </button>
                        )}
                        {!esteClient && (
                        <button type="button" className="btn-secundar" title={t('compozitor2', 'waLinkHintCard')}
                          disabled={!poateAprobare(cheie) || seTrimite} onClick={() => trimiteClientului([cheie])}>
                          {t('compozitor2', 'trimiteClientuluiWhatsApp')}
                        </button>
                        )}
                        {eInLinkulViu(cheie) && (
                          <span className="v2-actiuni-motiv">{t('compozitor2', 'inLinkulClientului')}</span>
                        )}
                        {(stariRand[cheie] === 'programat' || stariRand[cheie] === 'aprobare_finala' || stariRand[cheie] === 'intern') && (
                          <span className="v2-actiuni-motiv">{t('compozitor2', 'modificareIntoarce')}</span>
                        )}
                        {eGata(cheie) && motivProgramare(cheie) && (
                          <span className="v2-actiuni-motiv">{textMotivProgramare(motivProgramare(cheie))}</span>
                        )}
                      </div>
                    )}
                  </article>
                );
              })}
            </>
          )}

          {carduriSalvabile.length > 0 && (poateActiona ? (
            <div className="v2-bara-actiuni">
              <span className="v2-bara-actiuni-titlu">
                {t('compozitor2', 'toateCardurile', { n: carduriSalvabile.length })}
              </span>
              <div className="v2-bara-actiuni-butoane">
                <button type="button" className="btn-secundar"
                  disabled={!carduriDeTrimis.length || !carduriDeTrimis.every(poateAprobare) || seTrimite} onClick={() => trimite(esteClient ? 'intern' : 'aprobare_finala', carduriDeTrimis)}>
                  {t('compozitor2', esteClient ? 'trimiteEchipaNM' : 'trimiteAprobare')}
                </button>
                {poatePublicaCont && (
                <button type="button" className="btn-secundar"
                  disabled={!carduriDeTrimis.length || !carduriDeTrimis.every(poateProgramare) || seTrimite} onClick={() => trimite('programat', carduriDeTrimis)}>
                  {t('compozitor2', 'programeaza')}
                </button>
                )}
                {poatePublicaCont && (
                <button type="button" className="btn-principal"
                  disabled={!carduriDeTrimis.length || !carduriDeTrimis.every(poatePublicare) || seTrimite} onClick={() => publica(carduriDeTrimis)}>
                  {t('compozitor2', 'publicaAcum')}
                </button>
                )}
                {!esteClient && (
                <button type="button" className="btn-secundar" title={t('compozitor2', 'waLinkHint')}
                  disabled={!carduriDeTrimis.length || !carduriDeTrimis.every(poateAprobare) || seTrimite} onClick={() => trimiteClientului(carduriDeTrimis)}>
                  {t('compozitor2', 'trimiteClientuluiWhatsApp')}
                </button>
                )}
              </div>
              {!esteClient && linkClient && (
                <p className="v2-bara-actiuni-hint" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  {linkClient.viu ? (
                    <>
                      <span>{t('compozitor2', 'linkViu', {
                        n: linkClient.postare_ids.length,
                        data: new Date(linkClient.expira_la).toLocaleDateString(getLocale(), { day: 'numeric', month: 'long' }),
                      })}</span>
                      {raspunsuriLink && (
                        <strong style={{ color: raspunsuriLink.asteapta ? '#8F5310' : '#1A6B3C' }}>
                          {raspunsuriLink.asteapta
                            ? t('compozitor2', 'linkRaspunsuri', { r: raspunsuriLink.r, n: raspunsuriLink.n, a: raspunsuriLink.asteapta })
                            : t('compozitor2', 'linkToateRaspunse', { n: raspunsuriLink.n })}
                        </strong>
                      )}
                      <button type="button" className="v2-btn-media mic" disabled={seTrimite} onClick={anuleazaLinkul}>
                        {t('compozitor2', 'anuleazaLinkul')}
                      </button>
                    </>
                  ) : (
                    <span>{linkClient.anulat_la ? t('compozitor2', 'linkAnulatStare') : t('compozitor2', 'linkExpirat')}</span>
                  )}
                </p>
              )}
              {!carduriDeTrimis.every(eGata) && (
                <p className="v2-bara-actiuni-hint">{t('compozitor2', 'toateTrebuieGata')}</p>
              )}
              {notaActiune && <p className="v2-actiune-nota" role="status">{notaActiune}</p>}
            </div>
          ) : (
            <p className="v2-nota">{t('compozitor2', 'faraDreptCreare')}</p>
          ))}

          {/* Panoul TikTok: UNUL singur, chiar daca sunt alese si „Video" si
              „Photo Mode". Asa era si in compozitorul vechi — setarile sunt ale
              postarii, nu ale cardului. Doua panouri ar insemna doua raspunsuri
              la aceeasi intrebare despre cine vede postarea.

              Durata o ia din videoul cardului de TikTok Video, ca sa poata
              verifica limita contului. La Photo Mode nu exista video, deci
              ramane 0 si verificarea nu se aplica. */}
          {clientId && carduri.some(c => canalDin(c).id === 'tiktok') && (
            <PanouTikTok
              clientId={clientId}
              tt={tt}
              onSchimba={setTt}
              durataSec={durataVideoTikTok()}
              onInfo={setInfoTikTok}
            />
          )}
        </section>
      </div>

      <Lupa tinta={lupa} onInchide={() => setLupa(null)} />
    </div>
  );
}
